export const municipios = [
  { id: 1, state_id: 1, name: 'Aguascalientes' },
  { id: 2, state_id: 1, name: 'Asientos' },
  { id: 3, state_id: 1, name: 'Calvillo' },
  { id: 4, state_id: 1, name: 'Cosío' },
  { id: 5, state_id: 1, name: 'Jesús María' },
  { id: 6, state_id: 1, name: 'Pabellón de Arteaga' },
  { id: 7, state_id: 1, name: 'Rincón de Romos' },
  { inegi_id: 1008.0, id: 8, state_id: 1, name: 'San José de Gracia' },
  { inegi_id: 1009.0, id: 9, state_id: 1, name: 'Tepezalá' },
  { id: 10, state_id: 1, name: 'El Llano' },
  { id: 11, state_id: 1, name: 'San Francisco de los Romo' },
  { id: 1, state_id: 2, name: 'Ensenada' },
  { id: 2, state_id: 2, name: 'Mexicali' },
  { id: 3, state_id: 2, name: 'Tecate' },
  { id: 4, state_id: 2, name: 'Tijuana' },
  { id: 5, state_id: 2, name: 'Playas de Rosarito' },
  { id: 1, state_id: 3, name: 'Comondú' },
  { id: 2, state_id: 3, name: 'Mulegé' },
  { id: 3, state_id: 3, name: 'La Paz' },
  { inegi_id: 3008.0, id: 8, state_id: 3, name: 'Los Cabos' },
  { inegi_id: 3009.0, id: 9, state_id: 3, name: 'Loreto' },
  { id: 1, state_id: 4, name: 'Calkiní' },
  { id: 2, state_id: 4, name: 'Campeche' },
  { id: 3, state_id: 4, name: 'Carmen' },
  { id: 4, state_id: 4, name: 'Champotón' },
  { id: 5, state_id: 4, name: 'Hecelchakán' },
  { id: 6, state_id: 4, name: 'Hopelchén' },
  { id: 7, state_id: 4, name: 'Palizada' },
  { inegi_id: 4008.0, id: 8, state_id: 4, name: 'Tenabo' },
  { inegi_id: 4009.0, id: 9, state_id: 4, name: 'Escárcega' },
  { id: 10, state_id: 4, name: 'Calakmul' },
  { id: 11, state_id: 4, name: 'Candelaria' },
  { id: 1, state_id: 5, name: 'Abasolo' },
  { id: 2, state_id: 5, name: 'Acuña' },
  { id: 3, state_id: 5, name: 'Allende' },
  { id: 4, state_id: 5, name: 'Arteaga' },
  { id: 5, state_id: 5, name: 'Candela' },
  { id: 6, state_id: 5, name: 'Castaños' },
  { id: 7, state_id: 5, name: 'Cuatro Ciénegas' },
  { inegi_id: 5008.0, id: 8, state_id: 5, name: 'Escobedo' },
  { inegi_id: 5009.0, id: 9, state_id: 5, name: 'Francisco I. Madero' },
  { id: 10, state_id: 5, name: 'Frontera' },
  { id: 11, state_id: 5, name: 'General Cepeda' },
  { id: 12, state_id: 5, name: 'Guerrero' },
  { id: 13, state_id: 5, name: 'Hidalgo' },
  { id: 14, state_id: 5, name: 'Jiménez' },
  { id: 15, state_id: 5, name: 'Juárez' },
  { id: 16, state_id: 5, name: 'Lamadrid' },
  { id: 17, state_id: 5, name: 'Matamoros' },
  { inegi_id: 5018.0, id: 18, state_id: 5, name: 'Monclova' },
  { inegi_id: 5019.0, id: 19, state_id: 5, name: 'Morelos' },
  { id: 20, state_id: 5, name: 'Múzquiz' },
  { id: 21, state_id: 5, name: 'Nadadores' },
  { id: 22, state_id: 5, name: 'Nava' },
  { id: 23, state_id: 5, name: 'Ocampo' },
  { id: 24, state_id: 5, name: 'Parras' },
  { id: 25, state_id: 5, name: 'Piedras Negras' },
  { id: 26, state_id: 5, name: 'Progreso' },
  { id: 27, state_id: 5, name: 'Ramos Arizpe' },
  { inegi_id: 5028.0, id: 28, state_id: 5, name: 'Sabinas' },
  { inegi_id: 5029.0, id: 29, state_id: 5, name: 'Sacramento' },
  { id: 30, state_id: 5, name: 'Saltillo' },
  { id: 31, state_id: 5, name: 'San Buenaventura' },
  { id: 32, state_id: 5, name: 'San Juan de Sabinas' },
  { id: 33, state_id: 5, name: 'San Pedro' },
  { id: 34, state_id: 5, name: 'Sierra Mojada' },
  { id: 35, state_id: 5, name: 'Torreón' },
  { id: 36, state_id: 5, name: 'Viesca' },
  { id: 37, state_id: 5, name: 'Villa Unión' },
  { inegi_id: 5038.0, id: 38, state_id: 5, name: 'Zaragoza' },
  { id: 1, state_id: 6, name: 'Armería' },
  { id: 2, state_id: 6, name: 'Colima' },
  { id: 3, state_id: 6, name: 'Comala' },
  { id: 4, state_id: 6, name: 'Coquimatlán' },
  { id: 5, state_id: 6, name: 'Cuauhtémoc' },
  { id: 6, state_id: 6, name: 'Ixtlahuacán' },
  { id: 7, state_id: 6, name: 'Manzanillo' },
  { inegi_id: 6008.0, id: 8, state_id: 6, name: 'Minatitlán' },
  { inegi_id: 6009.0, id: 9, state_id: 6, name: 'Tecomán' },
  { id: 10, state_id: 6, name: 'Villa de Álvarez' },
  { id: 1, state_id: 7, name: 'Acacoyagua' },
  { id: 2, state_id: 7, name: 'Acala' },
  { id: 3, state_id: 7, name: 'Acapetahua' },
  { id: 4, state_id: 7, name: 'Altamirano' },
  { id: 5, state_id: 7, name: 'Amatán' },
  { id: 6, state_id: 7, name: 'Amatenango de la Frontera' },
  { id: 7, state_id: 7, name: 'Amatenango del Valle' },
  { inegi_id: 7008.0, id: 8, state_id: 7, name: 'Angel Albino Corzo' },
  { inegi_id: 7009.0, id: 9, state_id: 7, name: 'Arriaga' },
  { id: 10, state_id: 7, name: 'Bejucal de Ocampo' },
  { id: 11, state_id: 7, name: 'Bella Vista' },
  { id: 12, state_id: 7, name: 'Berriozábal' },
  { id: 13, state_id: 7, name: 'Bochil' },
  { id: 14, state_id: 7, name: 'El Bosque' },
  { id: 15, state_id: 7, name: 'Cacahoatán' },
  { id: 16, state_id: 7, name: 'Catazajá' },
  { id: 17, state_id: 7, name: 'Cintalapa' },
  { inegi_id: 7018.0, id: 18, state_id: 7, name: 'Coapilla' },
  { inegi_id: 7019.0, id: 19, state_id: 7, name: 'Comitán de Domínguez' },
  { id: 20, state_id: 7, name: 'La Concordia' },
  { id: 21, state_id: 7, name: 'Copainalá' },
  { id: 22, state_id: 7, name: 'Chalchihuitán' },
  { id: 23, state_id: 7, name: 'Chamula' },
  { id: 24, state_id: 7, name: 'Chanal' },
  { id: 25, state_id: 7, name: 'Chapultenango' },
  { id: 26, state_id: 7, name: 'Chenalhó' },
  { id: 27, state_id: 7, name: 'Chiapa de Corzo' },
  { inegi_id: 7028.0, id: 28, state_id: 7, name: 'Chiapilla' },
  { inegi_id: 7029.0, id: 29, state_id: 7, name: 'Chicoasén' },
  { id: 30, state_id: 7, name: 'Chicomuselo' },
  { id: 31, state_id: 7, name: 'Chilón' },
  { id: 32, state_id: 7, name: 'Escuintla' },
  { id: 33, state_id: 7, name: 'Francisco León' },
  { id: 34, state_id: 7, name: 'Frontera Comalapa' },
  { id: 35, state_id: 7, name: 'Frontera Hidalgo' },
  { id: 36, state_id: 7, name: 'La Grandeza' },
  { id: 37, state_id: 7, name: 'Huehuetán' },
  { inegi_id: 7038.0, id: 38, state_id: 7, name: 'Huixtán' },
  { inegi_id: 7039.0, id: 39, state_id: 7, name: 'Huitiupán' },
  { id: 40, state_id: 7, name: 'Huixtla' },
  { id: 41, state_id: 7, name: 'La Independencia' },
  { id: 42, state_id: 7, name: 'Ixhuatán' },
  { id: 43, state_id: 7, name: 'Ixtacomitán' },
  { id: 44, state_id: 7, name: 'Ixtapa' },
  { id: 45, state_id: 7, name: 'Ixtapangajoya' },
  { id: 46, state_id: 7, name: 'Jiquipilas' },
  { id: 47, state_id: 7, name: 'Jitotol' },
  { inegi_id: 7048.0, id: 48, state_id: 7, name: 'Juárez' },
  { inegi_id: 7049.0, id: 49, state_id: 7, name: 'Larráinzar' },
  { id: 50, state_id: 7, name: 'La Libertad' },
  { id: 51, state_id: 7, name: 'Mapastepec' },
  { id: 52, state_id: 7, name: 'Las Margaritas' },
  { id: 53, state_id: 7, name: 'Mazapa de Madero' },
  { id: 54, state_id: 7, name: 'Mazatán' },
  { id: 55, state_id: 7, name: 'Metapa' },
  { id: 56, state_id: 7, name: 'Mitontic' },
  { id: 57, state_id: 7, name: 'Motozintla' },
  { inegi_id: 7058.0, id: 58, state_id: 7, name: 'Nicolás Ruíz' },
  { inegi_id: 7059.0, id: 59, state_id: 7, name: 'Ocosingo' },
  { id: 60, state_id: 7, name: 'Ocotepec' },
  { id: 61, state_id: 7, name: 'Ocozocoautla de Espinosa' },
  { id: 62, state_id: 7, name: 'Ostuacán' },
  { id: 63, state_id: 7, name: 'Osumacinta' },
  { id: 64, state_id: 7, name: 'Oxchuc' },
  { id: 65, state_id: 7, name: 'Palenque' },
  { id: 66, state_id: 7, name: 'Pantelhó' },
  { id: 67, state_id: 7, name: 'Pantepec' },
  { inegi_id: 7068.0, id: 68, state_id: 7, name: 'Pichucalco' },
  { inegi_id: 7069.0, id: 69, state_id: 7, name: 'Pijijiapan' },
  { id: 70, state_id: 7, name: 'El Porvenir' },
  { id: 71, state_id: 7, name: 'Villa Comaltitlán' },
  { id: 72, state_id: 7, name: 'Pueblo Nuevo Solistahuacán' },
  { id: 73, state_id: 7, name: 'Rayón' },
  { id: 74, state_id: 7, name: 'Reforma' },
  { id: 75, state_id: 7, name: 'Las Rosas' },
  { id: 76, state_id: 7, name: 'Sabanilla' },
  { id: 77, state_id: 7, name: 'Salto de Agua' },
  { inegi_id: 7078.0, id: 78, state_id: 7, name: 'San Cristóbal de las Casas' },
  { inegi_id: 7079.0, id: 79, state_id: 7, name: 'San Fernando' },
  { inegi_id: 7080.0, id: 80, state_id: 7, name: 'Siltepec' },
  { inegi_id: 7081.0, id: 81, state_id: 7, name: 'Simojovel' },
  { inegi_id: 7082.0, id: 82, state_id: 7, name: 'Sitalá' },
  { inegi_id: 7083.0, id: 83, state_id: 7, name: 'Socoltenango' },
  { inegi_id: 7084.0, id: 84, state_id: 7, name: 'Solosuchiapa' },
  { inegi_id: 7085.0, id: 85, state_id: 7, name: 'Soyaló' },
  { inegi_id: 7086.0, id: 86, state_id: 7, name: 'Suchiapa' },
  { inegi_id: 7087.0, id: 87, state_id: 7, name: 'Suchiate' },
  { inegi_id: 7088.0, id: 88, state_id: 7, name: 'Sunuapa' },
  { inegi_id: 7089.0, id: 89, state_id: 7, name: 'Tapachula' },
  { inegi_id: 7090.0, id: 90, state_id: 7, name: 'Tapalapa' },
  { inegi_id: 7091.0, id: 91, state_id: 7, name: 'Tapilula' },
  { inegi_id: 7092.0, id: 92, state_id: 7, name: 'Tecpatán' },
  { inegi_id: 7093.0, id: 93, state_id: 7, name: 'Tenejapa' },
  { inegi_id: 7094.0, id: 94, state_id: 7, name: 'Teopisca' },
  { inegi_id: 7096.0, id: 96, state_id: 7, name: 'Tila' },
  { inegi_id: 7097.0, id: 97, state_id: 7, name: 'Tonalá' },
  { inegi_id: 7098.0, id: 98, state_id: 7, name: 'Totolapa' },
  { inegi_id: 7099.0, id: 99, state_id: 7, name: 'La Trinitaria' },
  { id: 100, state_id: 7, name: 'Tumbalá' },
  { id: 101, state_id: 7, name: 'Tuxtla Gutiérrez' },
  { id: 102, state_id: 7, name: 'Tuxtla Chico' },
  { id: 103, state_id: 7, name: 'Tuzantán' },
  { id: 104, state_id: 7, name: 'Tzimol' },
  { id: 105, state_id: 7, name: 'Unión Juárez' },
  { id: 106, state_id: 7, name: 'Venustiano Carranza' },
  { id: 107, state_id: 7, name: 'Villa Corzo' },
  { inegi_id: 7108.0, id: 108, state_id: 7, name: 'Villaflores' },
  { inegi_id: 7109.0, id: 109, state_id: 7, name: 'Yajalón' },
  { id: 110, state_id: 7, name: 'San Lucas' },
  { id: 111, state_id: 7, name: 'Zinacantán' },
  { id: 112, state_id: 7, name: 'San Juan Cancuc' },
  { id: 113, state_id: 7, name: 'Aldama' },
  { id: 114, state_id: 7, name: 'Benemérito de las Américas' },
  { id: 115, state_id: 7, name: 'Maravilla Tenejapa' },
  { id: 116, state_id: 7, name: 'Marqués de Comillas' },
  { id: 117, state_id: 7, name: 'Montecristo de Guerrero' },
  { inegi_id: 7118.0, id: 118, state_id: 7, name: 'San Andrés Duraznal' },
  { inegi_id: 7119.0, id: 119, state_id: 7, name: 'Santiago el Pinar' },
  { inegi_id: 8001.0, id: 1, state_id: 8, name: 'Ahumada' },
  { inegi_id: 8002.0, id: 2, state_id: 8, name: 'Aldama' },
  { inegi_id: 8003.0, id: 3, state_id: 8, name: 'Allende' },
  { inegi_id: 8004.0, id: 4, state_id: 8, name: 'Aquiles Serdán' },
  { inegi_id: 8005.0, id: 5, state_id: 8, name: 'Ascensión' },
  { inegi_id: 8006.0, id: 6, state_id: 8, name: 'Bachíniva' },
  { inegi_id: 8007.0, id: 7, state_id: 8, name: 'Balleza' },
  { inegi_id: 8008.0, id: 8, state_id: 8, name: 'Batopilas' },
  { inegi_id: 8009.0, id: 9, state_id: 8, name: 'Bocoyna' },
  { inegi_id: 8010.0, id: 10, state_id: 8, name: 'Buenaventura' },
  { inegi_id: 8011.0, id: 11, state_id: 8, name: 'Camargo' },
  { inegi_id: 8012.0, id: 12, state_id: 8, name: 'Carichí' },
  { inegi_id: 8013.0, id: 13, state_id: 8, name: 'Casas Grandes' },
  { inegi_id: 8014.0, id: 14, state_id: 8, name: 'Coronado' },
  { inegi_id: 8015.0, id: 15, state_id: 8, name: 'Coyame del Sotol' },
  { inegi_id: 8016.0, id: 16, state_id: 8, name: 'La Cruz' },
  { inegi_id: 8017.0, id: 17, state_id: 8, name: 'Cuauhtémoc' },
  { inegi_id: 8018.0, id: 18, state_id: 8, name: 'Cusihuiriachi' },
  { inegi_id: 8019.0, id: 19, state_id: 8, name: 'Chihuahua' },
  { inegi_id: 8020.0, id: 20, state_id: 8, name: 'Chínipas' },
  { inegi_id: 8021.0, id: 21, state_id: 8, name: 'Delicias' },
  { inegi_id: 8022.0, id: 22, state_id: 8, name: 'Dr. Belisario Domínguez' },
  { inegi_id: 8023.0, id: 23, state_id: 8, name: 'Galeana' },
  { inegi_id: 8024.0, id: 24, state_id: 8, name: 'Santa Isabel' },
  { inegi_id: 8025.0, id: 25, state_id: 8, name: 'Gómez Farías' },
  { inegi_id: 8026.0, id: 26, state_id: 8, name: 'Gran Morelos' },
  { inegi_id: 8027.0, id: 27, state_id: 8, name: 'Guachochi' },
  { inegi_id: 8028.0, id: 28, state_id: 8, name: 'Guadalupe' },
  { inegi_id: 8029.0, id: 29, state_id: 8, name: 'Guadalupe y Calvo' },
  { inegi_id: 8030.0, id: 30, state_id: 8, name: 'Guazapares' },
  { inegi_id: 8031.0, id: 31, state_id: 8, name: 'Guerrero' },
  { inegi_id: 8032.0, id: 32, state_id: 8, name: 'Hidalgo del Parral' },
  { inegi_id: 8033.0, id: 33, state_id: 8, name: 'Huejotitán' },
  { inegi_id: 8034.0, id: 34, state_id: 8, name: 'Ignacio Zaragoza' },
  { inegi_id: 8035.0, id: 35, state_id: 8, name: 'Janos' },
  { inegi_id: 8036.0, id: 36, state_id: 8, name: 'Jiménez' },
  { inegi_id: 8037.0, id: 37, state_id: 8, name: 'Juárez' },
  { inegi_id: 8038.0, id: 38, state_id: 8, name: 'Julimes' },
  { inegi_id: 8039.0, id: 39, state_id: 8, name: 'López' },
  { inegi_id: 8040.0, id: 40, state_id: 8, name: 'Madera' },
  { inegi_id: 8041.0, id: 41, state_id: 8, name: 'Maguarichi' },
  { inegi_id: 8042.0, id: 42, state_id: 8, name: 'Manuel Benavides' },
  { inegi_id: 8043.0, id: 43, state_id: 8, name: 'Matachí' },
  { inegi_id: 8044.0, id: 44, state_id: 8, name: 'Matamoros' },
  { inegi_id: 8045.0, id: 45, state_id: 8, name: 'Meoqui' },
  { inegi_id: 8046.0, id: 46, state_id: 8, name: 'Morelos' },
  { inegi_id: 8047.0, id: 47, state_id: 8, name: 'Moris' },
  { inegi_id: 8048.0, id: 48, state_id: 8, name: 'Namiquipa' },
  { inegi_id: 8049.0, id: 49, state_id: 8, name: 'Nonoava' },
  { inegi_id: 8050.0, id: 50, state_id: 8, name: 'Nuevo Casas Grandes' },
  { inegi_id: 8051.0, id: 51, state_id: 8, name: 'Ocampo' },
  { inegi_id: 8052.0, id: 52, state_id: 8, name: 'Ojinaga' },
  { inegi_id: 8053.0, id: 53, state_id: 8, name: 'Praxedis G. Guerrero' },
  { inegi_id: 8054.0, id: 54, state_id: 8, name: 'Riva Palacio' },
  { inegi_id: 8055.0, id: 55, state_id: 8, name: 'Rosales' },
  { inegi_id: 8056.0, id: 56, state_id: 8, name: 'Rosario' },
  { inegi_id: 8057.0, id: 57, state_id: 8, name: 'San Francisco de Borja' },
  { inegi_id: 8058.0, id: 58, state_id: 8, name: 'San Francisco de Conchos' },
  { inegi_id: 8059.0, id: 59, state_id: 8, name: 'San Francisco del Oro' },
  { inegi_id: 8060.0, id: 60, state_id: 8, name: 'Santa Bárbara' },
  { inegi_id: 8061.0, id: 61, state_id: 8, name: 'Satevó' },
  { inegi_id: 8062.0, id: 62, state_id: 8, name: 'Saucillo' },
  { inegi_id: 8063.0, id: 63, state_id: 8, name: 'Temósachi' },
  { inegi_id: 8064.0, id: 64, state_id: 8, name: 'El Tule' },
  { inegi_id: 8065.0, id: 65, state_id: 8, name: 'Urique' },
  { inegi_id: 8066.0, id: 66, state_id: 8, name: 'Uruachi' },
  { inegi_id: 8067.0, id: 67, state_id: 8, name: 'Valle de Zaragoza' },
  { inegi_id: 9002.0, id: 2, state_id: 9, name: 'Azcapotzalco' },
  { inegi_id: 9003.0, id: 3, state_id: 9, name: 'Coyoacán' },
  { inegi_id: 9004.0, id: 4, state_id: 9, name: 'Cuajimalpa de Morelos' },
  { inegi_id: 9005.0, id: 5, state_id: 9, name: 'Gustavo A. Madero' },
  { inegi_id: 9006.0, id: 6, state_id: 9, name: 'Iztacalco' },
  { inegi_id: 9007.0, id: 7, state_id: 9, name: 'Iztapalapa' },
  { inegi_id: 9008.0, id: 8, state_id: 9, name: 'La Magdalena Contreras' },
  { inegi_id: 9009.0, id: 9, state_id: 9, name: 'Milpa Alta' },
  { inegi_id: 9010.0, id: 10, state_id: 9, name: 'Álvaro Obregón' },
  { inegi_id: 9011.0, id: 11, state_id: 9, name: 'Tláhuac' },
  { inegi_id: 9012.0, id: 12, state_id: 9, name: 'Tlalpan' },
  { inegi_id: 9013.0, id: 13, state_id: 9, name: 'Xochimilco' },
  { inegi_id: 9014.0, id: 14, state_id: 9, name: 'Benito Juárez' },
  { inegi_id: 9015.0, id: 15, state_id: 9, name: 'Cuauhtémoc' },
  { inegi_id: 9016.0, id: 16, state_id: 9, name: 'Miguel Hidalgo' },
  { inegi_id: 9017.0, id: 17, state_id: 9, name: 'Venustiano Carranza' },
  { id: 1, state_id: 10, name: 'Canatlán' },
  { id: 2, state_id: 10, name: 'Canelas' },
  { id: 3, state_id: 10, name: 'Coneto de Comonfort' },
  { id: 4, state_id: 10, name: 'Cuencamé' },
  { id: 5, state_id: 10, name: 'Durango' },
  { id: 6, state_id: 10, name: 'General Simón Bolívar' },
  { id: 7, state_id: 10, name: 'Gómez Palacio' },
  { id: 8, state_id: 10, name: 'Guadalupe Victoria' },
  { id: 9, state_id: 10, name: 'Guanaceví' },
  { id: 10, state_id: 10, name: 'Hidalgo' },
  { id: 11, state_id: 10, name: 'Indé' },
  { id: 12, state_id: 10, name: 'Lerdo' },
  { id: 13, state_id: 10, name: 'Mapimí' },
  { id: 14, state_id: 10, name: 'Mezquital' },
  { id: 15, state_id: 10, name: 'Nazas' },
  { id: 16, state_id: 10, name: 'Nombre de Dios' },
  { id: 17, state_id: 10, name: 'Ocampo' },
  { id: 18, state_id: 10, name: 'El Oro' },
  { id: 19, state_id: 10, name: 'Otáez' },
  { id: 20, state_id: 10, name: 'Pánuco de Coronado' },
  { id: 21, state_id: 10, name: 'Peñón Blanco' },
  { id: 22, state_id: 10, name: 'Poanas' },
  { id: 23, state_id: 10, name: 'Pueblo Nuevo' },
  { id: 24, state_id: 10, name: 'Rodeo' },
  { id: 25, state_id: 10, name: 'San Bernardo' },
  { id: 26, state_id: 10, name: 'San Dimas' },
  { id: 27, state_id: 10, name: 'San Juan de Guadalupe' },
  { id: 28, state_id: 10, name: 'San Juan del Río' },
  { id: 29, state_id: 10, name: 'San Luis del Cordero' },
  { id: 30, state_id: 10, name: 'San Pedro del Gallo' },
  { id: 31, state_id: 10, name: 'Santa Clara' },
  { id: 32, state_id: 10, name: 'Santiago Papasquiaro' },
  { id: 33, state_id: 10, name: 'Súchil' },
  { id: 34, state_id: 10, name: 'Tamazula' },
  { id: 35, state_id: 10, name: 'Tepehuanes' },
  { id: 36, state_id: 10, name: 'Tlahualilo' },
  { id: 37, state_id: 10, name: 'Topia' },
  { id: 38, state_id: 10, name: 'Vicente Guerrero' },
  { id: 39, state_id: 10, name: 'Nuevo Ideal' },
  { id: 1, state_id: 11, name: 'Abasolo' },
  { id: 2, state_id: 11, name: 'Acámbaro' },
  { id: 3, state_id: 11, name: 'San Miguel de Allende' },
  { id: 4, state_id: 11, name: 'Apaseo el Alto' },
  { id: 5, state_id: 11, name: 'Apaseo el Grande' },
  { id: 6, state_id: 11, name: 'Atarjea' },
  { id: 7, state_id: 11, name: 'Celaya' },
  { id: 8, state_id: 11, name: 'Manuel Doblado' },
  { id: 9, state_id: 11, name: 'Comonfort' },
  { id: 10, state_id: 11, name: 'Coroneo' },
  { id: 11, state_id: 11, name: 'Cortazar' },
  { id: 12, state_id: 11, name: 'Cuerámaro' },
  { id: 13, state_id: 11, name: 'Doctor Mora' },
  {
    inegi_id: 11014,
    id: 14,
    state_id: 11,
    name: 'Dolores Hidalgo Cuna de la Independencia Nal.'
  },
  { id: 15, state_id: 11, name: 'Guanajuato' },
  { id: 16, state_id: 11, name: 'Huanímaro' },
  { id: 17, state_id: 11, name: 'Irapuato' },
  { id: 18, state_id: 11, name: 'Jaral del Progreso' },
  { id: 19, state_id: 11, name: 'Jerécuaro' },
  { id: 20, state_id: 11, name: 'León' },
  { id: 21, state_id: 11, name: 'Moroleón' },
  { id: 22, state_id: 11, name: 'Ocampo' },
  { id: 23, state_id: 11, name: 'Pénjamo' },
  { id: 24, state_id: 11, name: 'Pueblo Nuevo' },
  { id: 25, state_id: 11, name: 'Purísima del Rincón' },
  { id: 26, state_id: 11, name: 'Romita' },
  { id: 27, state_id: 11, name: 'Salamanca' },
  { id: 28, state_id: 11, name: 'Salvatierra' },
  { id: 29, state_id: 11, name: 'San Diego de la Unión' },
  { id: 30, state_id: 11, name: 'San Felipe' },
  { id: 31, state_id: 11, name: 'San Francisco del Rincón' },
  { id: 32, state_id: 11, name: 'San José Iturbide' },
  { id: 33, state_id: 11, name: 'San Luis de la Paz' },
  { id: 34, state_id: 11, name: 'Santa Catarina' },
  {
    inegi_id: 11035,
    id: 35,
    state_id: 11,
    name: 'Santa Cruz de Juventino Rosas'
  },
  { id: 36, state_id: 11, name: 'Santiago Maravatío' },
  { id: 37, state_id: 11, name: 'Silao' },
  { id: 38, state_id: 11, name: 'Tarandacuao' },
  { id: 39, state_id: 11, name: 'Tarimoro' },
  { id: 40, state_id: 11, name: 'Tierra Blanca' },
  { id: 41, state_id: 11, name: 'Uriangato' },
  { id: 42, state_id: 11, name: 'Valle de Santiago' },
  { id: 43, state_id: 11, name: 'Victoria' },
  { id: 44, state_id: 11, name: 'Villagrán' },
  { id: 45, state_id: 11, name: 'Xichú' },
  { id: 46, state_id: 11, name: 'Yuriria' },
  { id: 1, state_id: 12, name: 'Acapulco de Juárez' },
  { id: 2, state_id: 12, name: 'Ahuacuotzingo' },
  { id: 3, state_id: 12, name: 'Ajuchitlán del Progreso' },
  { id: 4, state_id: 12, name: 'Alcozauca de Guerrero' },
  { id: 5, state_id: 12, name: 'Alpoyeca' },
  { id: 6, state_id: 12, name: 'Apaxtla' },
  { id: 7, state_id: 12, name: 'Arcelia' },
  { id: 8, state_id: 12, name: 'Atenango del Río' },
  { id: 9, state_id: 12, name: 'Atlamajalcingo del Monte' },
  { id: 10, state_id: 12, name: 'Atlixtac' },
  { id: 11, state_id: 12, name: 'Atoyac de Álvarez' },
  { id: 12, state_id: 12, name: 'Ayutla de los Libres' },
  { id: 13, state_id: 12, name: 'Azoyú' },
  { id: 14, state_id: 12, name: 'Benito Juárez' },
  { id: 15, state_id: 12, name: 'Buenavista de Cuéllar' },
  {
    inegi_id: 12016,
    id: 16,
    state_id: 12,
    name: 'Coahuayutla de José María Izazaga'
  },
  { id: 17, state_id: 12, name: 'Cocula' },
  { id: 18, state_id: 12, name: 'Copala' },
  { id: 19, state_id: 12, name: 'Copalillo' },
  { id: 20, state_id: 12, name: 'Copanatoyac' },
  { id: 21, state_id: 12, name: 'Coyuca de Benítez' },
  { id: 22, state_id: 12, name: 'Coyuca de Catalán' },
  { id: 23, state_id: 12, name: 'Cuajinicuilapa' },
  { id: 24, state_id: 12, name: 'Cualác' },
  { id: 25, state_id: 12, name: 'Cuautepec' },
  { id: 26, state_id: 12, name: 'Cuetzala del Progreso' },
  { id: 27, state_id: 12, name: 'Cutzamala de Pinzón' },
  { id: 28, state_id: 12, name: 'Chilapa de Álvarez' },
  { id: 29, state_id: 12, name: 'Chilpancingo de los Bravo' },
  { id: 30, state_id: 12, name: 'Florencio Villarreal' },
  { id: 31, state_id: 12, name: 'General Canuto A. Neri' },
  { id: 32, state_id: 12, name: 'General Heliodoro Castillo' },
  { id: 33, state_id: 12, name: 'Huamuxtitlán' },
  { id: 34, state_id: 12, name: 'Huitzuco de los Figueroa' },
  { id: 35, state_id: 12, name: 'Iguala de la Independencia' },
  { id: 36, state_id: 12, name: 'Igualapa' },
  { id: 37, state_id: 12, name: 'Ixcateopan de Cuauhtémoc' },
  { id: 38, state_id: 12, name: 'José Azueta' },
  { id: 39, state_id: 12, name: 'Juan R. Escudero' },
  { id: 40, state_id: 12, name: 'Leonardo Bravo' },
  { id: 41, state_id: 12, name: 'Malinaltepec' },
  { id: 42, state_id: 12, name: 'Mártir de Cuilapan' },
  { id: 43, state_id: 12, name: 'Metlatónoc' },
  { id: 44, state_id: 12, name: 'Mochitlán' },
  { id: 45, state_id: 12, name: 'Olinalá ' },
  { id: 46, state_id: 12, name: 'Ometepec' },
  { id: 47, state_id: 12, name: 'Pedro Ascencio Alquisiras' },
  { id: 48, state_id: 12, name: 'Petatlán' },
  { id: 49, state_id: 12, name: 'Pilcaya' },
  { id: 50, state_id: 12, name: 'Pungarabato' },
  { id: 51, state_id: 12, name: 'Quechultenango' },
  { id: 52, state_id: 12, name: 'San Luis Acatlán' },
  { id: 53, state_id: 12, name: 'San Marcos' },
  { id: 54, state_id: 12, name: 'San Miguel Totolapan' },
  { id: 55, state_id: 12, name: 'Taxco de Alarcón' },
  { id: 56, state_id: 12, name: 'Tecoanapa' },
  { id: 57, state_id: 12, name: 'Técpan de Galeana' },
  { id: 58, state_id: 12, name: 'Teloloapan' },
  { id: 59, state_id: 12, name: 'Tepecoacuilco de Trujano' },
  { id: 60, state_id: 12, name: 'Tetipac' },
  { id: 61, state_id: 12, name: 'Tixtla de Guerrero' },
  { id: 62, state_id: 12, name: 'Tlacoachistlahuaca' },
  { id: 63, state_id: 12, name: 'Tlacoapa' },
  { id: 64, state_id: 12, name: 'Tlalchapa' },
  {
    inegi_id: 12065,
    id: 65,
    state_id: 12,
    name: 'Tlalixtaquilla de Maldonado'
  },
  { id: 66, state_id: 12, name: 'Tlapa de Comonfort' },
  { id: 67, state_id: 12, name: 'Tlapehuala' },
  {
    inegi_id: 12068,
    id: 68,
    state_id: 12,
    name: 'La Unión de Isidoro Montes de Oca'
  },
  { id: 69, state_id: 12, name: 'Xalpatláhuac' },
  { id: 70, state_id: 12, name: 'Xochihuehuetlán' },
  { id: 71, state_id: 12, name: 'Xochistlahuaca' },
  { id: 72, state_id: 12, name: 'Zapotitlán Tablas' },
  { id: 73, state_id: 12, name: 'Zirándaro' },
  { id: 74, state_id: 12, name: 'Zitlala' },
  { id: 75, state_id: 12, name: 'Eduardo Neri' },
  { id: 76, state_id: 12, name: 'Acatepec' },
  { id: 77, state_id: 12, name: 'Marquelia' },
  { id: 78, state_id: 12, name: 'Cochoapa el Grande' },
  { id: 79, state_id: 12, name: 'José Joaquín de Herrera' },
  { id: 80, state_id: 12, name: 'Juchitán' },
  { id: 81, state_id: 12, name: 'Iliatenco' },
  { id: 1, state_id: 13, name: 'Acatlán' },
  { id: 2, state_id: 13, name: 'Acaxochitlán' },
  { id: 3, state_id: 13, name: 'Actopan' },
  { id: 4, state_id: 13, name: 'Agua Blanca de Iturbide' },
  { id: 5, state_id: 13, name: 'Ajacuba' },
  { id: 6, state_id: 13, name: 'Alfajayucan' },
  { id: 7, state_id: 13, name: 'Almoloya' },
  { id: 8, state_id: 13, name: 'Apan' },
  { id: 9, state_id: 13, name: 'El Arenal' },
  { id: 10, state_id: 13, name: 'Atitalaquia' },
  { id: 11, state_id: 13, name: 'Atlapexco' },
  { id: 12, state_id: 13, name: 'Atotonilco el Grande' },
  { id: 13, state_id: 13, name: 'Atotonilco de Tula' },
  { id: 14, state_id: 13, name: 'Calnali' },
  { id: 15, state_id: 13, name: 'Cardonal' },
  { id: 16, state_id: 13, name: 'Cuautepec de Hinojosa' },
  { id: 17, state_id: 13, name: 'Chapantongo' },
  { id: 18, state_id: 13, name: 'Chapulhuacán' },
  { id: 19, state_id: 13, name: 'Chilcuautla' },
  { id: 20, state_id: 13, name: 'Eloxochitlán' },
  { id: 21, state_id: 13, name: 'Emiliano Zapata' },
  { id: 22, state_id: 13, name: 'Epazoyucan' },
  { id: 23, state_id: 13, name: 'Francisco I. Madero' },
  { id: 24, state_id: 13, name: 'Huasca de Ocampo' },
  { id: 25, state_id: 13, name: 'Huautla' },
  { id: 26, state_id: 13, name: 'Huazalingo' },
  { id: 27, state_id: 13, name: 'Huehuetla' },
  { id: 28, state_id: 13, name: 'Huejutla de Reyes' },
  { id: 29, state_id: 13, name: 'Huichapan' },
  { id: 30, state_id: 13, name: 'Ixmiquilpan' },
  { id: 31, state_id: 13, name: 'Jacala de Ledezma' },
  { id: 32, state_id: 13, name: 'Jaltocán' },
  { id: 33, state_id: 13, name: 'Juárez Hidalgo' },
  { id: 34, state_id: 13, name: 'Lolotla' },
  { id: 35, state_id: 13, name: 'Metepec' },
  { id: 36, state_id: 13, name: 'San Agustín Metzquititlán' },
  { id: 37, state_id: 13, name: 'Metztitlán' },
  { id: 38, state_id: 13, name: 'Mineral del Chico' },
  { id: 39, state_id: 13, name: 'Mineral del Monte' },
  { id: 40, state_id: 13, name: 'La Misión' },
  { id: 41, state_id: 13, name: 'Mixquiahuala de Juárez' },
  { id: 42, state_id: 13, name: 'Molango de Escamilla' },
  { id: 43, state_id: 13, name: 'Nicolás Flores' },
  { id: 44, state_id: 13, name: 'Nopala de Villagrán' },
  { id: 45, state_id: 13, name: 'Omitlán de Juárez' },
  { id: 46, state_id: 13, name: 'San Felipe Orizatlán' },
  { id: 47, state_id: 13, name: 'Pacula' },
  { id: 48, state_id: 13, name: 'Pachuca de Soto' },
  { id: 49, state_id: 13, name: 'Pisaflores' },
  { id: 50, state_id: 13, name: 'Progreso de Obregón' },
  { id: 51, state_id: 13, name: 'Mineral de la Reforma' },
  { id: 52, state_id: 13, name: 'San Agustín Tlaxiaca' },
  { id: 53, state_id: 13, name: 'San Bartolo Tutotepec' },
  { id: 54, state_id: 13, name: 'San Salvador' },
  { id: 55, state_id: 13, name: 'Santiago de Anaya' },
  {
    inegi_id: 13056,
    id: 56,
    state_id: 13,
    name: 'Santiago Tulantepec de Lugo Guerrero'
  },
  { id: 57, state_id: 13, name: 'Singuilucan' },
  { id: 58, state_id: 13, name: 'Tasquillo' },
  { id: 59, state_id: 13, name: 'Tecozautla' },
  { id: 60, state_id: 13, name: 'Tenango de Doria' },
  { id: 61, state_id: 13, name: 'Tepeapulco' },
  { id: 62, state_id: 13, name: 'Tepehuacán de Guerrero' },
  { id: 63, state_id: 13, name: 'Tepeji del Río de Ocampo' },
  { id: 64, state_id: 13, name: 'Tepetitlán' },
  { id: 65, state_id: 13, name: 'Tetepango' },
  { id: 66, state_id: 13, name: 'Villa de Tezontepec' },
  { id: 67, state_id: 13, name: 'Tezontepec de Aldama' },
  { id: 68, state_id: 13, name: 'Tianguistengo' },
  { id: 69, state_id: 13, name: 'Tizayuca' },
  { id: 70, state_id: 13, name: 'Tlahuelilpan' },
  { id: 71, state_id: 13, name: 'Tlahuiltepa' },
  { id: 72, state_id: 13, name: 'Tlanalapa' },
  { id: 73, state_id: 13, name: 'Tlanchinol' },
  { id: 74, state_id: 13, name: 'Tlaxcoapan' },
  { id: 75, state_id: 13, name: 'Tolcayuca' },
  { id: 76, state_id: 13, name: 'Tula de Allende' },
  { id: 77, state_id: 13, name: 'Tulancingo de Bravo' },
  { id: 78, state_id: 13, name: 'Xochiatipan' },
  { id: 79, state_id: 13, name: 'Xochicoatlán' },
  { id: 80, state_id: 13, name: 'Yahualica' },
  { id: 81, state_id: 13, name: 'Zacualtipán de Ángeles' },
  { id: 82, state_id: 13, name: 'Zapotlán de Juárez' },
  { id: 83, state_id: 13, name: 'Zempoala' },
  { id: 84, state_id: 13, name: 'Zimapán' },
  { id: 1, state_id: 14, name: 'Acatic' },
  { id: 2, state_id: 14, name: 'Acatlán de Juárez' },
  { id: 3, state_id: 14, name: 'Ahualulco de Mercado' },
  { id: 4, state_id: 14, name: 'Amacueca' },
  { id: 5, state_id: 14, name: 'Amatitán' },
  { id: 6, state_id: 14, name: 'Ameca' },
  { id: 7, state_id: 14, name: 'San Juanito de Escobedo' },
  { id: 8, state_id: 14, name: 'Arandas' },
  { id: 9, state_id: 14, name: 'El Arenal' },
  { id: 10, state_id: 14, name: 'Atemajac de Brizuela' },
  { id: 11, state_id: 14, name: 'Atengo' },
  { id: 12, state_id: 14, name: 'Atenguillo' },
  { id: 13, state_id: 14, name: 'Atotonilco el Alto' },
  { id: 14, state_id: 14, name: 'Atoyac' },
  { id: 15, state_id: 14, name: 'Autlán de Navarro' },
  { id: 16, state_id: 14, name: 'Ayotlán' },
  { id: 17, state_id: 14, name: 'Ayutla' },
  { id: 18, state_id: 14, name: 'La Barca' },
  { id: 19, state_id: 14, name: 'Bolaños' },
  { id: 20, state_id: 14, name: 'Cabo Corrientes' },
  { id: 21, state_id: 14, name: 'Casimiro Castillo' },
  { id: 22, state_id: 14, name: 'Cihuatlán' },
  { id: 23, state_id: 14, name: 'Zapotlán el Grande' },
  { id: 24, state_id: 14, name: 'Cocula' },
  { id: 25, state_id: 14, name: 'Colotlán' },
  { id: 26, state_id: 14, name: 'Concepción de Buenos Aires' },
  {
    inegi_id: 14027,
    id: 27,
    state_id: 14,
    name: 'Cuautitlán de García Barragán'
  },
  { id: 28, state_id: 14, name: 'Cuautla' },
  { id: 29, state_id: 14, name: 'Cuquío' },
  { id: 30, state_id: 14, name: 'Chapala' },
  { id: 31, state_id: 14, name: 'Chimaltitán' },
  { id: 32, state_id: 14, name: 'Chiquilistlán' },
  { id: 33, state_id: 14, name: 'Degollado' },
  { id: 34, state_id: 14, name: 'Ejutla' },
  { id: 35, state_id: 14, name: 'Encarnación de Díaz' },
  { id: 36, state_id: 14, name: 'Etzatlán' },
  { id: 37, state_id: 14, name: 'El Grullo' },
  { id: 38, state_id: 14, name: 'Guachinango' },
  { id: 39, state_id: 14, name: 'Guadalajara' },
  { id: 40, state_id: 14, name: 'Hostotipaquillo' },
  { id: 41, state_id: 14, name: 'Huejúcar' },
  { id: 42, state_id: 14, name: 'Huejuquilla el Alto' },
  { id: 43, state_id: 14, name: 'La Huerta' },
  {
    inegi_id: 14044,
    id: 44,
    state_id: 14,
    name: 'Ixtlahuacán de los Membrillos'
  },
  { id: 45, state_id: 14, name: 'Ixtlahuacán del Río' },
  { id: 46, state_id: 14, name: 'Jalostotitlán' },
  { id: 47, state_id: 14, name: 'Jamay' },
  { id: 48, state_id: 14, name: 'Jesús María' },
  { id: 49, state_id: 14, name: 'Jilotlán de los Dolores' },
  { id: 50, state_id: 14, name: 'Jocotepec' },
  { id: 51, state_id: 14, name: 'Juanacatlán' },
  { id: 52, state_id: 14, name: 'Juchitlán' },
  { id: 53, state_id: 14, name: 'Lagos de Moreno' },
  { id: 54, state_id: 14, name: 'El Limón' },
  { id: 55, state_id: 14, name: 'Magdalena' },
  { id: 56, state_id: 14, name: 'Santa María del Oro' },
  { id: 57, state_id: 14, name: 'La Manzanilla de la Paz' },
  { id: 58, state_id: 14, name: 'Mascota' },
  { id: 59, state_id: 14, name: 'Mazamitla' },
  { id: 60, state_id: 14, name: 'Mexticacán' },
  { id: 61, state_id: 14, name: 'Mezquitic' },
  { id: 62, state_id: 14, name: 'Mixtlán' },
  { id: 63, state_id: 14, name: 'Ocotlán' },
  { id: 64, state_id: 14, name: 'Ojuelos de Jalisco' },
  { id: 65, state_id: 14, name: 'Pihuamo' },
  { id: 66, state_id: 14, name: 'Poncitlán' },
  { id: 67, state_id: 14, name: 'Puerto Vallarta' },
  { id: 68, state_id: 14, name: 'Villa Purificación' },
  { id: 69, state_id: 14, name: 'Quitupan' },
  { id: 70, state_id: 14, name: 'El Salto' },
  {
    inegi_id: 14071,
    id: 71,
    state_id: 14,
    name: 'San Cristóbal de la Barranca'
  },
  { id: 72, state_id: 14, name: 'San Diego de Alejandría' },
  { id: 73, state_id: 14, name: 'San Juan de los Lagos' },
  { id: 74, state_id: 14, name: 'San Julián' },
  { id: 75, state_id: 14, name: 'San Marcos' },
  { id: 76, state_id: 14, name: 'San Martín de Bolaños' },
  { id: 77, state_id: 14, name: 'San Martín Hidalgo' },
  { id: 78, state_id: 14, name: 'San Miguel el Alto' },
  { id: 79, state_id: 14, name: 'Gómez Farías' },
  { id: 80, state_id: 14, name: 'San Sebastián del Oeste' },
  { id: 81, state_id: 14, name: 'Santa María de los Ángeles' },
  { id: 82, state_id: 14, name: 'Sayula' },
  { id: 83, state_id: 14, name: 'Tala' },
  { id: 84, state_id: 14, name: 'Talpa de Allende' },
  { id: 85, state_id: 14, name: 'Tamazula de Gordiano' },
  { id: 86, state_id: 14, name: 'Tapalpa' },
  { id: 87, state_id: 14, name: 'Tecalitlán' },
  { id: 88, state_id: 14, name: 'Tecolotlán' },
  { id: 89, state_id: 14, name: 'Techaluta de Montenegro' },
  { id: 90, state_id: 14, name: 'Tenamaxtlán' },
  { id: 91, state_id: 14, name: 'Teocaltiche' },
  { id: 92, state_id: 14, name: 'Teocuitatlán de Corona' },
  { id: 93, state_id: 14, name: 'Tepatitlán de Morelos' },
  { id: 94, state_id: 14, name: 'Tequila' },
  { id: 95, state_id: 14, name: 'Teuchitlán' },
  { id: 96, state_id: 14, name: 'Tizapán el Alto' },
  { id: 97, state_id: 14, name: 'Tlajomulco de Zúñiga' },
  { id: 98, state_id: 14, name: 'Tlaquepaque' },
  { id: 99, state_id: 14, name: 'Tolimán' },
  { id: 100, state_id: 14, name: 'Tomatlán' },
  { id: 101, state_id: 14, name: 'Tonalá' },
  { id: 102, state_id: 14, name: 'Tonaya' },
  { id: 103, state_id: 14, name: 'Tonila' },
  { id: 104, state_id: 14, name: 'Totatiche' },
  { id: 105, state_id: 14, name: 'Tototlán' },
  { id: 106, state_id: 14, name: 'Tuxcacuesco' },
  { id: 107, state_id: 14, name: 'Tuxcueca' },
  { id: 108, state_id: 14, name: 'Tuxpan' },
  { id: 109, state_id: 14, name: 'Unión de San Antonio' },
  { id: 110, state_id: 14, name: 'Unión de Tula' },
  { id: 111, state_id: 14, name: 'Valle de Guadalupe' },
  { id: 112, state_id: 14, name: 'Valle de Juárez' },
  { id: 113, state_id: 14, name: 'San Gabriel' },
  { id: 114, state_id: 14, name: 'Villa Corona' },
  { id: 115, state_id: 14, name: 'Villa Guerrero' },
  { id: 116, state_id: 14, name: 'Villa Hidalgo' },
  { id: 117, state_id: 14, name: 'Cañadas de Obregón' },
  {
    inegi_id: 14118,
    id: 118,
    state_id: 14,
    name: 'Yahualica de González Gallo'
  },
  { id: 119, state_id: 14, name: 'Zacoalco de Torres' },
  { id: 120, state_id: 14, name: 'Zapopan' },
  { id: 121, state_id: 14, name: 'Zapotiltic' },
  { id: 122, state_id: 14, name: 'Zapotitlán de Vadillo' },
  { id: 123, state_id: 14, name: 'Zapotlán del Rey' },
  { id: 124, state_id: 14, name: 'Zapotlanejo' },
  { id: 125, state_id: 14, name: 'San Ignacio Cerro Gordo' },
  { id: 1, state_id: 15, name: 'Acambay' },
  { id: 2, state_id: 15, name: 'Acolman' },
  { id: 3, state_id: 15, name: 'Aculco' },
  { id: 4, state_id: 15, name: 'Almoloya de Alquisiras' },
  { id: 5, state_id: 15, name: 'Almoloya de Juárez' },
  { id: 6, state_id: 15, name: 'Almoloya del Río' },
  { id: 7, state_id: 15, name: 'Amanalco' },
  { id: 8, state_id: 15, name: 'Amatepec' },
  { id: 9, state_id: 15, name: 'Amecameca' },
  { id: 10, state_id: 15, name: 'Apaxco' },
  { id: 11, state_id: 15, name: 'Atenco' },
  { id: 12, state_id: 15, name: 'Atizapán' },
  { id: 13, state_id: 15, name: 'Atizapán de Zaragoza' },
  { id: 14, state_id: 15, name: 'Atlacomulco' },
  { id: 15, state_id: 15, name: 'Atlautla' },
  { id: 16, state_id: 15, name: 'Axapusco' },
  { id: 17, state_id: 15, name: 'Ayapango' },
  { id: 18, state_id: 15, name: 'Calimaya' },
  { id: 19, state_id: 15, name: 'Capulhuac' },
  { id: 20, state_id: 15, name: 'Coacalco de Berriozábal' },
  { id: 21, state_id: 15, name: 'Coatepec Harinas' },
  { id: 22, state_id: 15, name: 'Cocotitlán' },
  { id: 23, state_id: 15, name: 'Coyotepec' },
  { id: 24, state_id: 15, name: 'Cuautitlán' },
  { id: 25, state_id: 15, name: 'Chalco' },
  { id: 26, state_id: 15, name: 'Chapa de Mota' },
  { id: 27, state_id: 15, name: 'Chapultepec' },
  { id: 28, state_id: 15, name: 'Chiautla' },
  { id: 29, state_id: 15, name: 'Chicoloapan' },
  { id: 30, state_id: 15, name: 'Chiconcuac' },
  { id: 31, state_id: 15, name: 'Chimalhuacán' },
  { id: 32, state_id: 15, name: 'Donato Guerra' },
  { id: 33, state_id: 15, name: 'Ecatepec de Morelos' },
  { id: 34, state_id: 15, name: 'Ecatzingo' },
  { id: 35, state_id: 15, name: 'Huehuetoca' },
  { id: 36, state_id: 15, name: 'Hueypoxtla' },
  { id: 37, state_id: 15, name: 'Huixquilucan' },
  { id: 38, state_id: 15, name: 'Isidro Fabela' },
  { id: 39, state_id: 15, name: 'Ixtapaluca' },
  { id: 40, state_id: 15, name: 'Ixtapan de la Sal' },
  { id: 41, state_id: 15, name: 'Ixtapan del Oro' },
  { id: 42, state_id: 15, name: 'Ixtlahuaca' },
  { id: 43, state_id: 15, name: 'Xalatlaco' },
  { id: 44, state_id: 15, name: 'Jaltenco' },
  { id: 45, state_id: 15, name: 'Jilotepec' },
  { id: 46, state_id: 15, name: 'Jilotzingo' },
  { id: 47, state_id: 15, name: 'Jiquipilco' },
  { id: 48, state_id: 15, name: 'Jocotitlán' },
  { id: 49, state_id: 15, name: 'Joquicingo' },
  { id: 50, state_id: 15, name: 'Juchitepec' },
  { id: 51, state_id: 15, name: 'Lerma' },
  { id: 52, state_id: 15, name: 'Malinalco' },
  { id: 53, state_id: 15, name: 'Melchor Ocampo' },
  { id: 54, state_id: 15, name: 'Metepec' },
  { id: 55, state_id: 15, name: 'Mexicaltzingo' },
  { id: 56, state_id: 15, name: 'Morelos' },
  { id: 57, state_id: 15, name: 'Naucalpan de Juárez' },
  { id: 58, state_id: 15, name: 'Nezahualcóyotl' },
  { id: 59, state_id: 15, name: 'Nextlalpan' },
  { id: 60, state_id: 15, name: 'Nicolás Romero' },
  { id: 61, state_id: 15, name: 'Nopaltepec' },
  { id: 62, state_id: 15, name: 'Ocoyoacac' },
  { id: 63, state_id: 15, name: 'Ocuilan' },
  { id: 64, state_id: 15, name: 'El Oro' },
  { id: 65, state_id: 15, name: 'Otumba' },
  { id: 66, state_id: 15, name: 'Otzoloapan' },
  { id: 67, state_id: 15, name: 'Otzolotepec' },
  { id: 68, state_id: 15, name: 'Ozumba' },
  { id: 69, state_id: 15, name: 'Papalotla' },
  { id: 70, state_id: 15, name: 'La Paz' },
  { id: 71, state_id: 15, name: 'Polotitlán' },
  { id: 72, state_id: 15, name: 'Rayón' },
  { id: 73, state_id: 15, name: 'San Antonio la Isla' },
  { id: 74, state_id: 15, name: 'San Felipe del Progreso' },
  {
    inegi_id: 15075,
    id: 75,
    state_id: 15,
    name: 'San Martín de las Pirámides'
  },
  { id: 76, state_id: 15, name: 'San Mateo Atenco' },
  { id: 77, state_id: 15, name: 'San Simón de Guerrero' },
  { id: 78, state_id: 15, name: 'Santo Tomás' },
  { id: 79, state_id: 15, name: 'Soyaniquilpan de Juárez' },
  { id: 80, state_id: 15, name: 'Sultepec' },
  { id: 81, state_id: 15, name: 'Tecámac' },
  { id: 82, state_id: 15, name: 'Tejupilco' },
  { id: 83, state_id: 15, name: 'Temamatla' },
  { id: 84, state_id: 15, name: 'Temascalapa' },
  { id: 85, state_id: 15, name: 'Temascalcingo' },
  { id: 86, state_id: 15, name: 'Temascaltepec' },
  { id: 87, state_id: 15, name: 'Temoaya' },
  { id: 88, state_id: 15, name: 'Tenancingo' },
  { id: 89, state_id: 15, name: 'Tenango del Aire' },
  { id: 90, state_id: 15, name: 'Tenango del Valle' },
  { id: 91, state_id: 15, name: 'Teoloyucán' },
  { id: 92, state_id: 15, name: 'Teotihuacán' },
  { id: 93, state_id: 15, name: 'Tepetlaoxtoc' },
  { id: 94, state_id: 15, name: 'Tepetlixpa' },
  { id: 95, state_id: 15, name: 'Tepotzotlán' },
  { id: 96, state_id: 15, name: 'Tequixquiac' },
  { id: 97, state_id: 15, name: 'Texcaltitlán' },
  { id: 98, state_id: 15, name: 'Texcalyacac' },
  { id: 99, state_id: 15, name: 'Texcoco' },
  { id: 100, state_id: 15, name: 'Tezoyuca' },
  { id: 101, state_id: 15, name: 'Tianguistenco' },
  { id: 102, state_id: 15, name: 'Timilpan' },
  { id: 103, state_id: 15, name: 'Tlalmanalco' },
  { id: 104, state_id: 15, name: 'Tlalnepantla de Baz' },
  { id: 105, state_id: 15, name: 'Tlatlaya' },
  { id: 106, state_id: 15, name: 'Toluca' },
  { id: 107, state_id: 15, name: 'Tonatico' },
  { id: 108, state_id: 15, name: 'Tultepec' },
  { id: 109, state_id: 15, name: 'Tultitlán' },
  { id: 110, state_id: 15, name: 'Valle de Bravo' },
  { id: 111, state_id: 15, name: 'Villa de Allende' },
  { id: 112, state_id: 15, name: 'Villa del Carbón' },
  { id: 113, state_id: 15, name: 'Villa Guerrero' },
  { id: 114, state_id: 15, name: 'Villa Victoria' },
  { id: 115, state_id: 15, name: 'Xonacatlán' },
  { id: 116, state_id: 15, name: 'Zacazonapan' },
  { id: 117, state_id: 15, name: 'Zacualpan' },
  { id: 118, state_id: 15, name: 'Zinacantepec' },
  { id: 119, state_id: 15, name: 'Zumpahuacán' },
  { id: 120, state_id: 15, name: 'Zumpango' },
  { id: 121, state_id: 15, name: 'Cuautitlán Izcalli' },
  {
    inegi_id: 15122,
    id: 122,
    state_id: 15,
    name: 'Valle de Chalco Solidaridad'
  },
  { id: 123, state_id: 15, name: 'Luvianos' },
  { id: 124, state_id: 15, name: 'San José del Rincón' },
  { id: 125, state_id: 15, name: 'Tonanitla' },
  { id: 1, state_id: 16, name: 'Acuitzio' },
  { id: 2, state_id: 16, name: 'Aguililla' },
  { id: 3, state_id: 16, name: 'Álvaro Obregón' },
  { id: 4, state_id: 16, name: 'Angamacutiro' },
  { id: 5, state_id: 16, name: 'Angangueo' },
  { id: 6, state_id: 16, name: 'Apatzingán' },
  { id: 7, state_id: 16, name: 'Aporo' },
  { id: 8, state_id: 16, name: 'Aquila' },
  { id: 9, state_id: 16, name: 'Ario' },
  { id: 10, state_id: 16, name: 'Arteaga' },
  { id: 11, state_id: 16, name: 'Briseñas' },
  { id: 12, state_id: 16, name: 'Buenavista' },
  { id: 13, state_id: 16, name: 'Carácuaro' },
  { id: 14, state_id: 16, name: 'Coahuayana' },
  {
    inegi_id: 16015,
    id: 15,
    state_id: 16,
    name: 'Coalcomán de Vázquez Pallares'
  },
  { id: 16, state_id: 16, name: 'Coeneo' },
  { id: 17, state_id: 16, name: 'Contepec' },
  { id: 18, state_id: 16, name: 'Copándaro' },
  { id: 19, state_id: 16, name: 'Cotija' },
  { id: 20, state_id: 16, name: 'Cuitzeo' },
  { id: 21, state_id: 16, name: 'Charapan' },
  { id: 22, state_id: 16, name: 'Charo' },
  { id: 23, state_id: 16, name: 'Chavinda' },
  { id: 24, state_id: 16, name: 'Cherán' },
  { id: 25, state_id: 16, name: 'Chilchota' },
  { id: 26, state_id: 16, name: 'Chinicuila' },
  { id: 27, state_id: 16, name: 'Chucándiro' },
  { id: 28, state_id: 16, name: 'Churintzio' },
  { id: 29, state_id: 16, name: 'Churumuco' },
  { id: 30, state_id: 16, name: 'Ecuandureo' },
  { id: 31, state_id: 16, name: 'Epitacio Huerta' },
  { id: 32, state_id: 16, name: 'Erongarícuaro' },
  { id: 33, state_id: 16, name: 'Gabriel Zamora' },
  { id: 34, state_id: 16, name: 'Hidalgo' },
  { id: 35, state_id: 16, name: 'La Huacana' },
  { id: 36, state_id: 16, name: 'Huandacareo' },
  { id: 37, state_id: 16, name: 'Huaniqueo' },
  { id: 38, state_id: 16, name: 'Huetamo' },
  { id: 39, state_id: 16, name: 'Huiramba' },
  { id: 40, state_id: 16, name: 'Indaparapeo' },
  { id: 41, state_id: 16, name: 'Irimbo' },
  { id: 42, state_id: 16, name: 'Ixtlán' },
  { id: 43, state_id: 16, name: 'Jacona' },
  { id: 44, state_id: 16, name: 'Jiménez' },
  { id: 45, state_id: 16, name: 'Jiquilpan' },
  { id: 46, state_id: 16, name: 'Juárez' },
  { id: 47, state_id: 16, name: 'Jungapeo' },
  { id: 48, state_id: 16, name: 'Lagunillas' },
  { id: 49, state_id: 16, name: 'Madero' },
  { id: 50, state_id: 16, name: 'Maravatío' },
  { id: 51, state_id: 16, name: 'Marcos Castellanos' },
  { id: 52, state_id: 16, name: 'Lázaro Cárdenas' },
  { id: 53, state_id: 16, name: 'Morelia' },
  { id: 54, state_id: 16, name: 'Morelos' },
  { id: 55, state_id: 16, name: 'Múgica' },
  { id: 56, state_id: 16, name: 'Nahuatzen' },
  { id: 57, state_id: 16, name: 'Nocupétaro' },
  { id: 58, state_id: 16, name: 'Nuevo Parangaricutiro' },
  { id: 59, state_id: 16, name: 'Nuevo Urecho' },
  { id: 60, state_id: 16, name: 'Numarán' },
  { id: 61, state_id: 16, name: 'Ocampo' },
  { id: 62, state_id: 16, name: 'Pajacuarán' },
  { id: 63, state_id: 16, name: 'Panindícuaro' },
  { id: 64, state_id: 16, name: 'Parácuaro' },
  { id: 65, state_id: 16, name: 'Paracho' },
  { id: 66, state_id: 16, name: 'Pátzcuaro' },
  { id: 67, state_id: 16, name: 'Penjamillo' },
  { id: 68, state_id: 16, name: 'Peribán' },
  { id: 69, state_id: 16, name: 'La Piedad' },
  { id: 70, state_id: 16, name: 'Purépero' },
  { id: 71, state_id: 16, name: 'Puruándiro' },
  { id: 72, state_id: 16, name: 'Queréndaro' },
  { id: 73, state_id: 16, name: 'Quiroga' },
  { id: 74, state_id: 16, name: 'Cojumatlán de Régules' },
  { id: 75, state_id: 16, name: 'Los Reyes' },
  { id: 76, state_id: 16, name: 'Sahuayo' },
  { id: 77, state_id: 16, name: 'San Lucas' },
  { id: 78, state_id: 16, name: 'Santa Ana Maya' },
  { id: 79, state_id: 16, name: 'Salvador Escalante' },
  { id: 80, state_id: 16, name: 'Senguio' },
  { id: 81, state_id: 16, name: 'Susupuato' },
  { id: 82, state_id: 16, name: 'Tacámbaro' },
  { id: 83, state_id: 16, name: 'Tancítaro' },
  { id: 84, state_id: 16, name: 'Tangamandapio' },
  { id: 85, state_id: 16, name: 'Tangancícuaro' },
  { id: 86, state_id: 16, name: 'Tanhuato' },
  { id: 87, state_id: 16, name: 'Taretan' },
  { id: 88, state_id: 16, name: 'Tarímbaro' },
  { id: 89, state_id: 16, name: 'Tepalcatepec' },
  { id: 90, state_id: 16, name: 'Tingambato' },
  { id: 91, state_id: 16, name: 'Tingüindín' },
  {
    inegi_id: 16092,
    id: 92,
    state_id: 16,
    name: 'Tiquicheo de Nicolás Romero'
  },
  { id: 93, state_id: 16, name: 'Tlalpujahua' },
  { id: 94, state_id: 16, name: 'Tlazazalca' },
  { id: 95, state_id: 16, name: 'Tocumbo' },
  { id: 96, state_id: 16, name: 'Tumbiscatío' },
  { id: 97, state_id: 16, name: 'Turicato' },
  { id: 98, state_id: 16, name: 'Tuxpan' },
  { id: 99, state_id: 16, name: 'Tuzantla' },
  { id: 100, state_id: 16, name: 'Tzintzuntzan' },
  { id: 101, state_id: 16, name: 'Tzitzio' },
  { id: 102, state_id: 16, name: 'Uruapan' },
  { id: 103, state_id: 16, name: 'Venustiano Carranza' },
  { id: 104, state_id: 16, name: 'Villamar' },
  { id: 105, state_id: 16, name: 'Vista Hermosa' },
  { id: 106, state_id: 16, name: 'Yurécuaro' },
  { id: 107, state_id: 16, name: 'Zacapu' },
  { id: 108, state_id: 16, name: 'Zamora' },
  { id: 109, state_id: 16, name: 'Zináparo' },
  { id: 110, state_id: 16, name: 'Zinapécuaro' },
  { id: 111, state_id: 16, name: 'Ziracuaretiro' },
  { id: 112, state_id: 16, name: 'Zitácuaro' },
  { id: 113, state_id: 16, name: 'José Sixto Verduzco' },
  { id: 1, state_id: 17, name: 'Amacuzac' },
  { id: 2, state_id: 17, name: 'Atlatlahucan' },
  { id: 3, state_id: 17, name: 'Axochiapan' },
  { id: 4, state_id: 17, name: 'Ayala' },
  { id: 5, state_id: 17, name: 'Coatlán del Río' },
  { id: 6, state_id: 17, name: 'Cuautla' },
  { id: 7, state_id: 17, name: 'Cuernavaca' },
  { id: 8, state_id: 17, name: 'Emiliano Zapata' },
  { id: 9, state_id: 17, name: 'Huitzilac' },
  { id: 10, state_id: 17, name: 'Jantetelco' },
  { id: 11, state_id: 17, name: 'Jiutepec' },
  { id: 12, state_id: 17, name: 'Jojutla' },
  { id: 13, state_id: 17, name: 'Jonacatepec' },
  { id: 14, state_id: 17, name: 'Mazatepec' },
  { id: 15, state_id: 17, name: 'Miacatlán' },
  { id: 16, state_id: 17, name: 'Ocuituco' },
  { id: 17, state_id: 17, name: 'Puente de Ixtla' },
  { id: 18, state_id: 17, name: 'Temixco' },
  { id: 19, state_id: 17, name: 'Tepalcingo' },
  { id: 20, state_id: 17, name: 'Tepoztlán' },
  { id: 21, state_id: 17, name: 'Tetecala' },
  { id: 22, state_id: 17, name: 'Tetela del Volcán' },
  { id: 23, state_id: 17, name: 'Tlalnepantla' },
  { id: 24, state_id: 17, name: 'Tlaltizapán' },
  { id: 25, state_id: 17, name: 'Tlaquiltenango' },
  { id: 26, state_id: 17, name: 'Tlayacapan' },
  { id: 27, state_id: 17, name: 'Totolapan' },
  { id: 28, state_id: 17, name: 'Xochitepec' },
  { id: 29, state_id: 17, name: 'Yautepec' },
  { id: 30, state_id: 17, name: 'Yecapixtla' },
  { id: 31, state_id: 17, name: 'Zacatepec de Hidalgo' },
  { id: 32, state_id: 17, name: 'Zacualpan de Amilpas' },
  { id: 33, state_id: 17, name: 'Temoac' },
  { id: 1, state_id: 18, name: 'Acaponeta' },
  { id: 2, state_id: 18, name: 'Ahuacatlán' },
  { id: 3, state_id: 18, name: 'Amatlán de Cañas' },
  { id: 4, state_id: 18, name: 'Compostela' },
  { id: 5, state_id: 18, name: 'Huajicori' },
  { id: 6, state_id: 18, name: 'Ixtlán del Río' },
  { id: 7, state_id: 18, name: 'Jala' },
  { id: 8, state_id: 18, name: 'Xalisco' },
  { id: 9, state_id: 18, name: 'Del Nayar' },
  { id: 10, state_id: 18, name: 'Rosamorada' },
  { id: 11, state_id: 18, name: 'Ruíz' },
  { id: 12, state_id: 18, name: 'San Blas' },
  { id: 13, state_id: 18, name: 'San Pedro Lagunillas' },
  { id: 14, state_id: 18, name: 'Santa María del Oro' },
  { id: 15, state_id: 18, name: 'Santiago Ixcuintla' },
  { id: 16, state_id: 18, name: 'Tecuala' },
  { id: 17, state_id: 18, name: 'Tepic' },
  { id: 18, state_id: 18, name: 'Tuxpan' },
  { id: 19, state_id: 18, name: 'La Yesca' },
  { id: 20, state_id: 18, name: 'Bahía de Banderas' },
  { id: 1, state_id: 19, name: 'Abasolo' },
  { id: 2, state_id: 19, name: 'Agualeguas' },
  { id: 3, state_id: 19, name: 'Los Aldamas' },
  { id: 4, state_id: 19, name: 'Allende' },
  { id: 5, state_id: 19, name: 'Anáhuac' },
  { id: 6, state_id: 19, name: 'Apodaca' },
  { id: 7, state_id: 19, name: 'Aramberri' },
  { id: 8, state_id: 19, name: 'Bustamante' },
  { id: 9, state_id: 19, name: 'Cadereyta Jiménez' },
  { id: 10, state_id: 19, name: 'Carmen' },
  { id: 11, state_id: 19, name: 'Cerralvo' },
  { id: 12, state_id: 19, name: 'Ciénega de Flores' },
  { id: 13, state_id: 19, name: 'China' },
  { id: 14, state_id: 19, name: 'Dr. Arroyo' },
  { id: 15, state_id: 19, name: 'Dr. Coss' },
  { id: 16, state_id: 19, name: 'Dr. González' },
  { id: 17, state_id: 19, name: 'Galeana' },
  { id: 18, state_id: 19, name: 'García' },
  { id: 19, state_id: 19, name: 'San Pedro Garza García' },
  { id: 20, state_id: 19, name: 'Gral. Bravo' },
  { id: 21, state_id: 19, name: 'Gral. Escobedo' },
  { id: 22, state_id: 19, name: 'Gral. Terán' },
  { id: 23, state_id: 19, name: 'Gral. Treviño' },
  { id: 24, state_id: 19, name: 'Gral. Zaragoza' },
  { id: 25, state_id: 19, name: 'Gral. Zuazua' },
  { id: 26, state_id: 19, name: 'Guadalupe' },
  { id: 27, state_id: 19, name: 'Los Herreras' },
  { id: 28, state_id: 19, name: 'Higueras' },
  { id: 29, state_id: 19, name: 'Hualahuises' },
  { id: 30, state_id: 19, name: 'Iturbide' },
  { id: 31, state_id: 19, name: 'Juárez' },
  { id: 32, state_id: 19, name: 'Lampazos de Naranjo' },
  { id: 33, state_id: 19, name: 'Linares' },
  { id: 34, state_id: 19, name: 'Marín' },
  { id: 35, state_id: 19, name: 'Melchor Ocampo' },
  { id: 36, state_id: 19, name: 'Mier y Noriega' },
  { id: 37, state_id: 19, name: 'Mina' },
  { id: 38, state_id: 19, name: 'Montemorelos' },
  { id: 39, state_id: 19, name: 'Monterrey' },
  { id: 40, state_id: 19, name: 'Parás' },
  { id: 41, state_id: 19, name: 'Pesquería' },
  { id: 42, state_id: 19, name: 'Los Ramones' },
  { id: 43, state_id: 19, name: 'Rayones' },
  { id: 44, state_id: 19, name: 'Sabinas Hidalgo' },
  { id: 45, state_id: 19, name: 'Salinas Victoria' },
  { id: 46, state_id: 19, name: 'San Nicolás de los Garza' },
  { id: 47, state_id: 19, name: 'Hidalgo' },
  { id: 48, state_id: 19, name: 'Santa Catarina' },
  { id: 49, state_id: 19, name: 'Santiago' },
  { id: 50, state_id: 19, name: 'Vallecillo' },
  { id: 51, state_id: 19, name: 'Villaldama' },
  { id: 1, state_id: 20, name: 'Abejones' },
  { id: 2, state_id: 20, name: 'Acatlán de Pérez Figueroa' },
  { id: 3, state_id: 20, name: 'Asunción Cacalotepec' },
  { id: 4, state_id: 20, name: 'Asunción Cuyotepeji' },
  { id: 5, state_id: 20, name: 'Asunción Ixtaltepec' },
  { id: 6, state_id: 20, name: 'Asunción Nochixtlán' },
  { id: 7, state_id: 20, name: 'Asunción Ocotlán' },
  { id: 8, state_id: 20, name: 'Asunción Tlacolulita' },
  { id: 9, state_id: 20, name: 'Ayotzintepec' },
  { id: 10, state_id: 20, name: 'El Barrio de la Soledad' },
  { id: 11, state_id: 20, name: 'Calihualá' },
  { id: 12, state_id: 20, name: 'Candelaria Loxicha' },
  { id: 13, state_id: 20, name: 'Ciénega de Zimatlán' },
  { id: 14, state_id: 20, name: 'Ciudad Ixtepec' },
  { id: 15, state_id: 20, name: 'Coatecas Altas' },
  { id: 16, state_id: 20, name: 'Coicoyán de las Flores' },
  { id: 17, state_id: 20, name: 'La Compañía' },
  { id: 18, state_id: 20, name: 'Concepción Buenavista' },
  { id: 19, state_id: 20, name: 'Concepción Pápalo' },
  { id: 20, state_id: 20, name: 'Constancia del Rosario' },
  { id: 21, state_id: 20, name: 'Cosolapa' },
  { id: 22, state_id: 20, name: 'Cosoltepec' },
  { id: 23, state_id: 20, name: 'Cuilápam de Guerrero' },
  {
    inegi_id: 20024,
    id: 24,
    state_id: 20,
    name: 'Cuyamecalco Villa de Zaragoza'
  },
  { id: 25, state_id: 20, name: 'Chahuites' },
  { id: 26, state_id: 20, name: 'Chalcatongo de Hidalgo' },
  {
    inegi_id: 20027,
    id: 27,
    state_id: 20,
    name: 'Chiquihuitlán de Benito Juárez'
  },
  {
    inegi_id: 20028,
    id: 28,
    state_id: 20,
    name: 'Heroica Ciudad de Ejutla de Crespo'
  },
  {
    inegi_id: 20029,
    id: 29,
    state_id: 20,
    name: 'Eloxochitlán de Flores Magón'
  },
  { id: 30, state_id: 20, name: 'El Espinal' },
  {
    inegi_id: 20031,
    id: 31,
    state_id: 20,
    name: 'Tamazulápam del Espíritu Santo'
  },
  { id: 32, state_id: 20, name: 'Fresnillo de Trujano' },
  { id: 33, state_id: 20, name: 'Guadalupe Etla' },
  { id: 34, state_id: 20, name: 'Guadalupe de Ramírez' },
  { id: 35, state_id: 20, name: 'Guelatao de Juárez' },
  { id: 36, state_id: 20, name: 'Guevea de Humboldt' },
  { id: 37, state_id: 20, name: 'Mesones Hidalgo' },
  { id: 38, state_id: 20, name: 'Villa Hidalgo' },
  {
    inegi_id: 20039,
    id: 39,
    state_id: 20,
    name: 'Heroica Ciudad de Huajuapan de León'
  },
  { id: 40, state_id: 20, name: 'Huautepec' },
  { id: 41, state_id: 20, name: 'Huautla de Jiménez' },
  { id: 42, state_id: 20, name: 'Ixtlán de Juárez' },
  { id: 43, state_id: 20, name: 'Juchitán de Zaragoza' },
  { id: 44, state_id: 20, name: 'Loma Bonita' },
  { id: 45, state_id: 20, name: 'Magdalena Apasco' },
  { id: 46, state_id: 20, name: 'Magdalena Jaltepec' },
  { id: 47, state_id: 20, name: 'Santa Magdalena Jicotlán' },
  { id: 48, state_id: 20, name: 'Magdalena Mixtepec' },
  { id: 49, state_id: 20, name: 'Magdalena Ocotlán' },
  { id: 50, state_id: 20, name: 'Magdalena Peñasco' },
  { id: 51, state_id: 20, name: 'Magdalena Teitipac' },
  { id: 52, state_id: 20, name: 'Magdalena Tequisistlán' },
  { id: 53, state_id: 20, name: 'Magdalena Tlacotepec' },
  { id: 54, state_id: 20, name: 'Magdalena Zahuatlán' },
  { id: 55, state_id: 20, name: 'Mariscala de Juárez' },
  { id: 56, state_id: 20, name: 'Mártires de Tacubaya' },
  { id: 57, state_id: 20, name: 'Matías Romero Avendaño' },
  { id: 58, state_id: 20, name: 'Mazatlán Villa de Flores' },
  {
    inegi_id: 20059,
    id: 59,
    state_id: 20,
    name: 'Miahuatlán de Porfirio Díaz'
  },
  { id: 60, state_id: 20, name: 'Mixistlán de la Reforma' },
  { id: 61, state_id: 20, name: 'Monjas' },
  { id: 62, state_id: 20, name: 'Natividad' },
  { id: 63, state_id: 20, name: 'Nazareno Etla' },
  { id: 64, state_id: 20, name: 'Nejapa de Madero' },
  { id: 65, state_id: 20, name: 'Ixpantepec Nieves' },
  { id: 66, state_id: 20, name: 'Santiago Niltepec' },
  { id: 67, state_id: 20, name: 'Oaxaca de Juárez' },
  { id: 68, state_id: 20, name: 'Ocotlán de Morelos' },
  { id: 69, state_id: 20, name: 'La Pe' },
  { id: 70, state_id: 20, name: 'Pinotepa de Don Luis' },
  { id: 71, state_id: 20, name: 'Pluma Hidalgo' },
  { id: 72, state_id: 20, name: 'San José del Progreso' },
  { id: 73, state_id: 20, name: 'Putla Villa de Guerrero' },
  { id: 74, state_id: 20, name: 'Santa Catarina Quioquitani' },
  { id: 75, state_id: 20, name: 'Reforma de Pineda' },
  { id: 76, state_id: 20, name: 'La Reforma' },
  { id: 77, state_id: 20, name: 'Reyes Etla' },
  { id: 78, state_id: 20, name: 'Rojas de Cuauhtémoc' },
  { id: 79, state_id: 20, name: 'Salina Cruz' },
  { id: 80, state_id: 20, name: 'San Agustín Amatengo' },
  { id: 81, state_id: 20, name: 'San Agustín Atenango' },
  { id: 82, state_id: 20, name: 'San Agustín Chayuco' },
  { id: 83, state_id: 20, name: 'San Agustín de las Juntas' },
  { id: 84, state_id: 20, name: 'San Agustín Etla' },
  { id: 85, state_id: 20, name: 'San Agustín Loxicha' },
  { id: 86, state_id: 20, name: 'San Agustín Tlacotepec' },
  { id: 87, state_id: 20, name: 'San Agustín Yatareni' },
  { id: 88, state_id: 20, name: 'San Andrés Cabecera Nueva' },
  { id: 89, state_id: 20, name: 'San Andrés Dinicuiti' },
  { id: 90, state_id: 20, name: 'San Andrés Huaxpaltepec' },
  { id: 91, state_id: 20, name: 'San Andrés Huayápam' },
  { id: 92, state_id: 20, name: 'San Andrés Ixtlahuaca' },
  { id: 93, state_id: 20, name: 'San Andrés Lagunas' },
  { id: 94, state_id: 20, name: 'San Andrés Nuxiño' },
  { id: 95, state_id: 20, name: 'San Andrés Paxtlán' },
  { id: 96, state_id: 20, name: 'San Andrés Sinaxtla' },
  { id: 97, state_id: 20, name: 'San Andrés Solaga' },
  { id: 98, state_id: 20, name: 'San Andrés Teotilálpam' },
  { id: 99, state_id: 20, name: 'San Andrés Tepetlapa' },
  { id: 100, state_id: 20, name: 'San Andrés Yaá' },
  { id: 101, state_id: 20, name: 'San Andrés Zabache' },
  { id: 102, state_id: 20, name: 'San Andrés Zautla' },
  {
    inegi_id: 20103,
    id: 103,
    state_id: 20,
    name: 'San Antonino Castillo Velasco'
  },
  { id: 104, state_id: 20, name: 'San Antonino el Alto' },
  { id: 105, state_id: 20, name: 'San Antonino Monte Verde' },
  { id: 106, state_id: 20, name: 'San Antonio Acutla' },
  { id: 107, state_id: 20, name: 'San Antonio de la Cal' },
  { id: 108, state_id: 20, name: 'San Antonio Huitepec' },
  { id: 109, state_id: 20, name: 'San Antonio Nanahuatípam' },
  { id: 110, state_id: 20, name: 'San Antonio Sinicahua' },
  { id: 111, state_id: 20, name: 'San Antonio Tepetlapa' },
  { id: 112, state_id: 20, name: 'San Baltazar Chichicápam' },
  { id: 113, state_id: 20, name: 'San Baltazar Loxicha' },
  {
    inegi_id: 20114,
    id: 114,
    state_id: 20,
    name: 'San Baltazar Yatzachi el Bajo'
  },
  { id: 115, state_id: 20, name: 'San Bartolo Coyotepec' },
  { id: 116, state_id: 20, name: 'San Bartolomé Ayautla' },
  { id: 117, state_id: 20, name: 'San Bartolomé Loxicha' },
  { id: 118, state_id: 20, name: 'San Bartolomé Quialana' },
  { id: 119, state_id: 20, name: 'San Bartolomé Yucuañe' },
  { id: 120, state_id: 20, name: 'San Bartolomé Zoogocho' },
  { id: 121, state_id: 20, name: 'San Bartolo Soyaltepec' },
  { id: 122, state_id: 20, name: 'San Bartolo Yautepec' },
  { id: 123, state_id: 20, name: 'San Bernardo Mixtepec' },
  { id: 124, state_id: 20, name: 'San Blas Atempa' },
  { id: 125, state_id: 20, name: 'San Carlos Yautepec' },
  { id: 126, state_id: 20, name: 'San Cristóbal Amatlán' },
  { id: 127, state_id: 20, name: 'San Cristóbal Amoltepec' },
  { id: 128, state_id: 20, name: 'San Cristóbal Lachirioag' },
  {
    inegi_id: 20129,
    id: 129,
    state_id: 20,
    name: 'San Cristóbal Suchixtlahuaca'
  },
  { id: 130, state_id: 20, name: 'San Dionisio del Mar' },
  { id: 131, state_id: 20, name: 'San Dionisio Ocotepec' },
  { id: 132, state_id: 20, name: 'San Dionisio Ocotlán' },
  { id: 133, state_id: 20, name: 'San Esteban Atatlahuca' },
  { id: 134, state_id: 20, name: 'San Felipe Jalapa de Díaz' },
  { id: 135, state_id: 20, name: 'San Felipe Tejalápam' },
  { id: 136, state_id: 20, name: 'San Felipe Usila' },
  { id: 137, state_id: 20, name: 'San Francisco Cahuacuá' },
  { id: 138, state_id: 20, name: 'San Francisco Cajonos' },
  { id: 139, state_id: 20, name: 'San Francisco Chapulapa' },
  { id: 140, state_id: 20, name: 'San Francisco Chindúa' },
  { id: 141, state_id: 20, name: 'San Francisco del Mar' },
  { id: 142, state_id: 20, name: 'San Francisco Huehuetlán' },
  { id: 143, state_id: 20, name: 'San Francisco Ixhuatán' },
  {
    inegi_id: 20144,
    id: 144,
    state_id: 20,
    name: 'San Francisco Jaltepetongo'
  },
  { id: 145, state_id: 20, name: 'San Francisco Lachigoló' },
  { id: 146, state_id: 20, name: 'San Francisco Logueche' },
  { id: 147, state_id: 20, name: 'San Francisco Nuxaño' },
  { id: 148, state_id: 20, name: 'San Francisco Ozolotepec' },
  { id: 149, state_id: 20, name: 'San Francisco Sola' },
  {
    inegi_id: 20150,
    id: 150,
    state_id: 20,
    name: 'San Francisco Telixtlahuaca'
  },
  { id: 151, state_id: 20, name: 'San Francisco Teopan' },
  { id: 152, state_id: 20, name: 'San Francisco Tlapancingo' },
  { id: 153, state_id: 20, name: 'San Gabriel Mixtepec' },
  { id: 154, state_id: 20, name: 'San Ildefonso Amatlán' },
  { id: 155, state_id: 20, name: 'San Ildefonso Sola' },
  { id: 156, state_id: 20, name: 'San Ildefonso Villa Alta' },
  { id: 157, state_id: 20, name: 'San Jacinto Amilpas' },
  { id: 158, state_id: 20, name: 'San Jacinto Tlacotepec' },
  { id: 159, state_id: 20, name: 'San Jerónimo Coatlán' },
  {
    inegi_id: 20160,
    id: 160,
    state_id: 20,
    name: 'San Jerónimo Silacayoapilla'
  },
  { id: 161, state_id: 20, name: 'San Jerónimo Sosola' },
  { id: 162, state_id: 20, name: 'San Jerónimo Taviche' },
  { id: 163, state_id: 20, name: 'San Jerónimo Tecóatl' },
  { id: 164, state_id: 20, name: 'San Jorge Nuchita' },
  { id: 165, state_id: 20, name: 'San José Ayuquila' },
  { id: 166, state_id: 20, name: 'San José Chiltepec' },
  { id: 167, state_id: 20, name: 'San José del Peñasco' },
  { id: 168, state_id: 20, name: 'San José Estancia Grande' },
  { id: 169, state_id: 20, name: 'San José Independencia' },
  { id: 170, state_id: 20, name: 'San José Lachiguiri' },
  { id: 171, state_id: 20, name: 'San José Tenango' },
  { id: 172, state_id: 20, name: 'San Juan Achiutla' },
  { id: 173, state_id: 20, name: 'San Juan Atepec' },
  { id: 174, state_id: 20, name: 'Ánimas Trujano' },
  {
    inegi_id: 20175,
    id: 175,
    state_id: 20,
    name: 'San Juan Bautista Atatlahuca'
  },
  {
    inegi_id: 20176,
    id: 176,
    state_id: 20,
    name: 'San Juan Bautista Coixtlahuaca'
  },
  {
    inegi_id: 20177,
    id: 177,
    state_id: 20,
    name: 'San Juan Bautista Cuicatlán'
  },
  {
    inegi_id: 20178,
    id: 178,
    state_id: 20,
    name: 'San Juan Bautista Guelache'
  },
  {
    inegi_id: 20179,
    id: 179,
    state_id: 20,
    name: 'San Juan Bautista Jayacatlán'
  },
  {
    inegi_id: 20180,
    id: 180,
    state_id: 20,
    name: 'San Juan Bautista Lo de Soto'
  },
  {
    inegi_id: 20181,
    id: 181,
    state_id: 20,
    name: 'San Juan Bautista Suchitepec'
  },
  {
    inegi_id: 20182,
    id: 182,
    state_id: 20,
    name: 'San Juan Bautista Tlacoatzintepec'
  },
  {
    inegi_id: 20183,
    id: 183,
    state_id: 20,
    name: 'San Juan Bautista Tlachichilco'
  },
  {
    inegi_id: 20184,
    id: 184,
    state_id: 20,
    name: 'San Juan Bautista Tuxtepec'
  },
  { id: 185, state_id: 20, name: 'San Juan Cacahuatepec' },
  { id: 186, state_id: 20, name: 'San Juan Cieneguilla' },
  { id: 187, state_id: 20, name: 'San Juan Coatzóspam' },
  { id: 188, state_id: 20, name: 'San Juan Colorado' },
  { id: 189, state_id: 20, name: 'San Juan Comaltepec' },
  { id: 190, state_id: 20, name: 'San Juan Cotzocón' },
  { id: 191, state_id: 20, name: 'San Juan Chicomezúchil' },
  { id: 192, state_id: 20, name: 'San Juan Chilateca' },
  { id: 193, state_id: 20, name: 'San Juan del Estado' },
  { id: 194, state_id: 20, name: 'San Juan del Río' },
  { id: 195, state_id: 20, name: 'San Juan Diuxi' },
  {
    inegi_id: 20196,
    id: 196,
    state_id: 20,
    name: 'San Juan Evangelista Analco'
  },
  { id: 197, state_id: 20, name: 'San Juan Guelavía' },
  { id: 198, state_id: 20, name: 'San Juan Guichicovi' },
  { id: 199, state_id: 20, name: 'San Juan Ihualtepec' },
  { id: 200, state_id: 20, name: 'San Juan Juquila Mixes' },
  { id: 201, state_id: 20, name: 'San Juan Juquila Vijanos' },
  { id: 202, state_id: 20, name: 'San Juan Lachao' },
  { id: 203, state_id: 20, name: 'San Juan Lachigalla' },
  { id: 204, state_id: 20, name: 'San Juan Lajarcia' },
  { id: 205, state_id: 20, name: 'San Juan Lalana' },
  { id: 206, state_id: 20, name: 'San Juan de los Cués' },
  { id: 207, state_id: 20, name: 'San Juan Mazatlán' },
  {
    inegi_id: 20208,
    id: 208,
    state_id: 20,
    name: 'San Juan Mixtepec - Dto. 08 -'
  },
  {
    inegi_id: 20209,
    id: 209,
    state_id: 20,
    name: 'San Juan Mixtepec - Dto. 26 -'
  },
  { id: 210, state_id: 20, name: 'San Juan Ñumí' },
  { id: 211, state_id: 20, name: 'San Juan Ozolotepec' },
  { id: 212, state_id: 20, name: 'San Juan Petlapa' },
  { id: 213, state_id: 20, name: 'San Juan Quiahije' },
  { id: 214, state_id: 20, name: 'San Juan Quiotepec' },
  { id: 215, state_id: 20, name: 'San Juan Sayultepec' },
  { id: 216, state_id: 20, name: 'San Juan Tabaá' },
  { id: 217, state_id: 20, name: 'San Juan Tamazola' },
  { id: 218, state_id: 20, name: 'San Juan Teita' },
  { id: 219, state_id: 20, name: 'San Juan Teitipac' },
  { id: 220, state_id: 20, name: 'San Juan Tepeuxila' },
  { id: 221, state_id: 20, name: 'San Juan Teposcolula' },
  { id: 222, state_id: 20, name: 'San Juan Yaeé' },
  { id: 223, state_id: 20, name: 'San Juan Yatzona' },
  { id: 224, state_id: 20, name: 'San Juan Yucuita' },
  { id: 225, state_id: 20, name: 'San Lorenzo' },
  { id: 226, state_id: 20, name: 'San Lorenzo Albarradas' },
  { id: 227, state_id: 20, name: 'San Lorenzo Cacaotepec' },
  {
    inegi_id: 20228,
    id: 228,
    state_id: 20,
    name: 'San Lorenzo Cuaunecuiltitla'
  },
  { id: 229, state_id: 20, name: 'San Lorenzo Texmelúcan' },
  { id: 230, state_id: 20, name: 'San Lorenzo Victoria' },
  { id: 231, state_id: 20, name: 'San Lucas Camotlán' },
  { id: 232, state_id: 20, name: 'San Lucas Ojitlán' },
  { id: 233, state_id: 20, name: 'San Lucas Quiaviní' },
  { id: 234, state_id: 20, name: 'San Lucas Zoquiápam' },
  { id: 235, state_id: 20, name: 'San Luis Amatlán' },
  { id: 236, state_id: 20, name: 'San Marcial Ozolotepec' },
  { id: 237, state_id: 20, name: 'San Marcos Arteaga' },
  {
    inegi_id: 20238,
    id: 238,
    state_id: 20,
    name: 'San Martín de los Cansecos'
  },
  { id: 239, state_id: 20, name: 'San Martín Huamelúlpam' },
  { id: 240, state_id: 20, name: 'San Martín Itunyoso' },
  { id: 241, state_id: 20, name: 'San Martín Lachilá' },
  { id: 242, state_id: 20, name: 'San Martín Peras' },
  { id: 243, state_id: 20, name: 'San Martín Tilcajete' },
  { id: 244, state_id: 20, name: 'San Martín Toxpalan' },
  { id: 245, state_id: 20, name: 'San Martín Zacatepec' },
  { id: 246, state_id: 20, name: 'San Mateo Cajonos' },
  { id: 247, state_id: 20, name: 'Capulálpam de Méndez' },
  { id: 248, state_id: 20, name: 'San Mateo del Mar' },
  { id: 249, state_id: 20, name: 'San Mateo Yoloxochitlán' },
  { id: 250, state_id: 20, name: 'San Mateo Etlatongo' },
  { id: 251, state_id: 20, name: 'San Mateo Nejápam' },
  { id: 252, state_id: 20, name: 'San Mateo Peñasco' },
  { id: 253, state_id: 20, name: 'San Mateo Piñas' },
  { id: 254, state_id: 20, name: 'San Mateo Río Hondo' },
  { id: 255, state_id: 20, name: 'San Mateo Sindihui' },
  { id: 256, state_id: 20, name: 'San Mateo Tlapiltepec' },
  { id: 257, state_id: 20, name: 'San Melchor Betaza' },
  { id: 258, state_id: 20, name: 'San Miguel Achiutla' },
  { id: 259, state_id: 20, name: 'San Miguel Ahuehuetitlán' },
  { id: 260, state_id: 20, name: 'San Miguel Aloápam' },
  { id: 261, state_id: 20, name: 'San Miguel Amatitlán' },
  { id: 262, state_id: 20, name: 'San Miguel Amatlán' },
  { id: 263, state_id: 20, name: 'San Miguel Coatlán' },
  { id: 264, state_id: 20, name: 'San Miguel Chicahua' },
  { id: 265, state_id: 20, name: 'San Miguel Chimalapa' },
  { id: 266, state_id: 20, name: 'San Miguel del Puerto' },
  { id: 267, state_id: 20, name: 'San Miguel del Río' },
  { id: 268, state_id: 20, name: 'San Miguel Ejutla' },
  { id: 269, state_id: 20, name: 'San Miguel el Grande' },
  { id: 270, state_id: 20, name: 'San Miguel Huautla' },
  { id: 271, state_id: 20, name: 'San Miguel Mixtepec' },
  { id: 272, state_id: 20, name: 'San Miguel Panixtlahuaca' },
  { id: 273, state_id: 20, name: 'San Miguel Peras' },
  { id: 274, state_id: 20, name: 'San Miguel Piedras' },
  { id: 275, state_id: 20, name: 'San Miguel Quetzaltepec' },
  { id: 276, state_id: 20, name: 'San Miguel Santa Flor' },
  { id: 277, state_id: 20, name: 'Villa Sola de Vega' },
  { id: 278, state_id: 20, name: 'San Miguel Soyaltepec' },
  { id: 279, state_id: 20, name: 'San Miguel Suchixtepec' },
  { id: 280, state_id: 20, name: 'Villa Talea de Castro' },
  { id: 281, state_id: 20, name: 'San Miguel Tecomatlán' },
  { id: 282, state_id: 20, name: 'San Miguel Tenango' },
  { id: 283, state_id: 20, name: 'San Miguel Tequixtepec' },
  { id: 284, state_id: 20, name: 'San Miguel Tilquiápam' },
  { id: 285, state_id: 20, name: 'San Miguel Tlacamama' },
  { id: 286, state_id: 20, name: 'San Miguel Tlacotepec' },
  { id: 287, state_id: 20, name: 'San Miguel Tulancingo' },
  { id: 288, state_id: 20, name: 'San Miguel Yotao' },
  { id: 289, state_id: 20, name: 'San Nicolás' },
  { id: 290, state_id: 20, name: 'San Nicolás Hidalgo' },
  { id: 291, state_id: 20, name: 'San Pablo Coatlán' },
  { id: 292, state_id: 20, name: 'San Pablo Cuatro Venados' },
  { id: 293, state_id: 20, name: 'San Pablo Etla' },
  { id: 294, state_id: 20, name: 'San Pablo Huitzo' },
  { id: 295, state_id: 20, name: 'San Pablo Huixtepec' },
  { id: 296, state_id: 20, name: 'San Pablo Macuiltianguis' },
  { id: 297, state_id: 20, name: 'San Pablo Tijaltepec' },
  { id: 298, state_id: 20, name: 'San Pablo Villa de Mitla' },
  { id: 299, state_id: 20, name: 'San Pablo Yaganiza' },
  { id: 300, state_id: 20, name: 'San Pedro Amuzgos' },
  { id: 301, state_id: 20, name: 'San Pedro Apóstol' },
  { id: 302, state_id: 20, name: 'San Pedro Atoyac' },
  { id: 303, state_id: 20, name: 'San Pedro Cajonos' },
  {
    inegi_id: 20304,
    id: 304,
    state_id: 20,
    name: 'San Pedro Coxcaltepec Cántaros'
  },
  { id: 305, state_id: 20, name: 'San Pedro Comitancillo' },
  { id: 306, state_id: 20, name: 'San Pedro el Alto' },
  { id: 307, state_id: 20, name: 'San Pedro Huamelula' },
  { id: 308, state_id: 20, name: 'San Pedro Huilotepec' },
  { id: 309, state_id: 20, name: 'San Pedro Ixcatlán' },
  { id: 310, state_id: 20, name: 'San Pedro Ixtlahuaca' },
  { id: 311, state_id: 20, name: 'San Pedro Jaltepetongo' },
  { id: 312, state_id: 20, name: 'San Pedro Jicayán' },
  { id: 313, state_id: 20, name: 'San Pedro Jocotipac' },
  { id: 314, state_id: 20, name: 'San Pedro Juchatengo' },
  { id: 315, state_id: 20, name: 'San Pedro Mártir' },
  {
    inegi_id: 20316,
    id: 316,
    state_id: 20,
    name: 'San Pedro Mártir Quiechapa'
  },
  { id: 317, state_id: 20, name: 'San Pedro Mártir Yucuxaco' },
  {
    inegi_id: 20318,
    id: 318,
    state_id: 20,
    name: 'San Pedro Mixtepec - Dto. 22 -'
  },
  {
    inegi_id: 20319,
    id: 319,
    state_id: 20,
    name: 'San Pedro Mixtepec - Dto. 26 -'
  },
  { id: 320, state_id: 20, name: 'San Pedro Molinos' },
  { id: 321, state_id: 20, name: 'San Pedro Nopala' },
  { id: 322, state_id: 20, name: 'San Pedro Ocopetatillo' },
  { id: 323, state_id: 20, name: 'San Pedro Ocotepec' },
  { id: 324, state_id: 20, name: 'San Pedro Pochutla' },
  { id: 325, state_id: 20, name: 'San Pedro Quiatoni' },
  { id: 326, state_id: 20, name: 'San Pedro Sochiápam' },
  { id: 327, state_id: 20, name: 'San Pedro Tapanatepec' },
  { id: 328, state_id: 20, name: 'San Pedro Taviche' },
  { id: 329, state_id: 20, name: 'San Pedro Teozacoalco' },
  { id: 330, state_id: 20, name: 'San Pedro Teutila' },
  { id: 331, state_id: 20, name: 'San Pedro Tidaá' },
  { id: 332, state_id: 20, name: 'San Pedro Topiltepec' },
  { id: 333, state_id: 20, name: 'San Pedro Totolapa' },
  {
    inegi_id: 20334,
    id: 334,
    state_id: 20,
    name: 'Villa de Tututepec de Melchor Ocampo'
  },
  { id: 335, state_id: 20, name: 'San Pedro Yaneri' },
  { id: 336, state_id: 20, name: 'San Pedro Yólox' },
  {
    inegi_id: 20337,
    id: 337,
    state_id: 20,
    name: 'San Pedro y San Pablo Ayutla'
  },
  { id: 338, state_id: 20, name: 'Villa de Etla' },
  {
    inegi_id: 20339,
    id: 339,
    state_id: 20,
    name: 'San Pedro y San Pablo Teposcolula'
  },
  {
    inegi_id: 20340,
    id: 340,
    state_id: 20,
    name: 'San Pedro y San Pablo Tequixtepec'
  },
  { id: 341, state_id: 20, name: 'San Pedro Yucunama' },
  { id: 342, state_id: 20, name: 'San Raymundo Jalpan' },
  { id: 343, state_id: 20, name: 'San Sebastián Abasolo' },
  { id: 344, state_id: 20, name: 'San Sebastián Coatlán' },
  { id: 345, state_id: 20, name: 'San Sebastián Ixcapa' },
  { id: 346, state_id: 20, name: 'San Sebastián Nicananduta' },
  { id: 347, state_id: 20, name: 'San Sebastián Río Hondo' },
  {
    inegi_id: 20348,
    id: 348,
    state_id: 20,
    name: 'San Sebastián Tecomaxtlahuaca'
  },
  { id: 349, state_id: 20, name: 'San Sebastián Teitipac' },
  { id: 350, state_id: 20, name: 'San Sebastián Tutla' },
  { id: 351, state_id: 20, name: 'San Simón Almolongas' },
  { id: 352, state_id: 20, name: 'San Simón Zahuatlán' },
  { id: 353, state_id: 20, name: 'Santa Ana' },
  { id: 354, state_id: 20, name: 'Santa Ana Ateixtlahuaca' },
  { id: 355, state_id: 20, name: 'Santa Ana Cuauhtémoc' },
  { id: 356, state_id: 20, name: 'Santa Ana del Valle' },
  { id: 357, state_id: 20, name: 'Santa Ana Tavela' },
  { id: 358, state_id: 20, name: 'Santa Ana Tlapacoyan' },
  { id: 359, state_id: 20, name: 'Santa Ana Yareni' },
  { id: 360, state_id: 20, name: 'Santa Ana Zegache' },
  { id: 361, state_id: 20, name: 'Santa Catalina Quierí' },
  { id: 362, state_id: 20, name: 'Santa Catarina Cuixtla' },
  { id: 363, state_id: 20, name: 'Santa Catarina Ixtepeji' },
  { id: 364, state_id: 20, name: 'Santa Catarina Juquila' },
  { id: 365, state_id: 20, name: 'Santa Catarina Lachatao' },
  { id: 366, state_id: 20, name: 'Santa Catarina Loxicha' },
  { id: 367, state_id: 20, name: 'Santa Catarina Mechoacán' },
  { id: 368, state_id: 20, name: 'Santa Catarina Minas' },
  { id: 369, state_id: 20, name: 'Santa Catarina Quiané' },
  { id: 370, state_id: 20, name: 'Santa Catarina Tayata' },
  { id: 371, state_id: 20, name: 'Santa Catarina Ticuá' },
  { id: 372, state_id: 20, name: 'Santa Catarina Yosonotú' },
  { id: 373, state_id: 20, name: 'Santa Catarina Zapoquila' },
  { id: 374, state_id: 20, name: 'Santa Cruz Acatepec' },
  { id: 375, state_id: 20, name: 'Santa Cruz Amilpas' },
  { id: 376, state_id: 20, name: 'Santa Cruz de Bravo' },
  { id: 377, state_id: 20, name: 'Santa Cruz Itundujia' },
  { id: 378, state_id: 20, name: 'Santa Cruz Mixtepec' },
  { id: 379, state_id: 20, name: 'Santa Cruz Nundaco' },
  { id: 380, state_id: 20, name: 'Santa Cruz Papalutla' },
  {
    inegi_id: 20381,
    id: 381,
    state_id: 20,
    name: 'Santa Cruz Tacache de Mina'
  },
  { id: 382, state_id: 20, name: 'Santa Cruz Tacahua' },
  { id: 383, state_id: 20, name: 'Santa Cruz Tayata' },
  { id: 384, state_id: 20, name: 'Santa Cruz Xitla' },
  { id: 385, state_id: 20, name: 'Santa Cruz Xoxocotlán' },
  { id: 386, state_id: 20, name: 'Santa Cruz Zenzontepec' },
  { id: 387, state_id: 20, name: 'Santa Gertrudis' },
  { id: 388, state_id: 20, name: 'Santa Inés del Monte' },
  { id: 389, state_id: 20, name: 'Santa Inés Yatzeche' },
  { id: 390, state_id: 20, name: 'Santa Lucía del Camino' },
  { id: 391, state_id: 20, name: 'Santa Lucía Miahuatlán' },
  { id: 392, state_id: 20, name: 'Santa Lucía Monteverde' },
  { id: 393, state_id: 20, name: 'Santa Lucía Ocotlán' },
  { id: 394, state_id: 20, name: 'Santa María Alotepec' },
  { id: 395, state_id: 20, name: 'Santa María Apazco' },
  { id: 396, state_id: 20, name: 'Santa María la Asunción' },
  {
    inegi_id: 20397,
    id: 397,
    state_id: 20,
    name: 'Heroica Ciudad de Tlaxiaco'
  },
  { id: 398, state_id: 20, name: 'Ayoquezco de Aldama' },
  { id: 399, state_id: 20, name: 'Santa María Atzompa' },
  { id: 400, state_id: 20, name: 'Santa María Camotlán' },
  { id: 401, state_id: 20, name: 'Santa María Colotepec' },
  { id: 402, state_id: 20, name: 'Santa María Cortijo' },
  { id: 403, state_id: 20, name: 'Santa María Coyotepec' },
  { id: 404, state_id: 20, name: 'Santa María Chachoápam' },
  { id: 405, state_id: 20, name: 'Villa de Chilapa de Díaz' },
  { id: 406, state_id: 20, name: 'Santa María Chilchotla' },
  { id: 407, state_id: 20, name: 'Santa María Chimalapa' },
  { id: 408, state_id: 20, name: 'Santa María del Rosario' },
  { id: 409, state_id: 20, name: 'Santa María del Tule' },
  { id: 410, state_id: 20, name: 'Santa María Ecatepec' },
  { id: 411, state_id: 20, name: 'Santa María Guelacé' },
  { id: 412, state_id: 20, name: 'Santa María Guienagati' },
  { id: 413, state_id: 20, name: 'Santa María Huatulco' },
  { id: 414, state_id: 20, name: 'Santa María Huazolotitlán' },
  { id: 415, state_id: 20, name: 'Santa María Ipalapa' },
  { id: 416, state_id: 20, name: 'Santa María Ixcatlán' },
  { id: 417, state_id: 20, name: 'Santa María Jacatepec' },
  {
    inegi_id: 20418,
    id: 418,
    state_id: 20,
    name: 'Santa María Jalapa del Marqués'
  },
  { id: 419, state_id: 20, name: 'Santa María Jaltianguis' },
  { id: 420, state_id: 20, name: 'Santa María Lachixío' },
  { id: 421, state_id: 20, name: 'Santa María Mixtequilla' },
  { id: 422, state_id: 20, name: 'Santa María Nativitas' },
  { id: 423, state_id: 20, name: 'Santa María Nduayaco' },
  { id: 424, state_id: 20, name: 'Santa María Ozolotepec' },
  { id: 425, state_id: 20, name: 'Santa María Pápalo' },
  { id: 426, state_id: 20, name: 'Santa María Peñoles' },
  { id: 427, state_id: 20, name: 'Santa María Petapa' },
  { id: 428, state_id: 20, name: 'Santa María Quiegolani' },
  { id: 429, state_id: 20, name: 'Santa María Sola' },
  { id: 430, state_id: 20, name: 'Santa María Tataltepec' },
  { id: 431, state_id: 20, name: 'Santa María Tecomavaca' },
  { id: 432, state_id: 20, name: 'Santa María Temaxcalapa' },
  { id: 433, state_id: 20, name: 'Santa María Temaxcaltepec' },
  { id: 434, state_id: 20, name: 'Santa María Teopoxco' },
  { id: 435, state_id: 20, name: 'Santa María Tepantlali' },
  { id: 436, state_id: 20, name: 'Santa María Texcatitlán' },
  {
    inegi_id: 20437,
    id: 437,
    state_id: 20,
    name: 'Santa María Tlahuitoltepec'
  },
  { id: 438, state_id: 20, name: 'Santa María Tlalixtac' },
  { id: 439, state_id: 20, name: 'Santa María Tonameca' },
  { id: 440, state_id: 20, name: 'Santa María Totolapilla' },
  { id: 441, state_id: 20, name: 'Santa María Xadani' },
  { id: 442, state_id: 20, name: 'Santa María Yalina' },
  { id: 443, state_id: 20, name: 'Santa María Yavesía' },
  { id: 444, state_id: 20, name: 'Santa María Yolotepec' },
  { id: 445, state_id: 20, name: 'Santa María Yosoyúa' },
  { id: 446, state_id: 20, name: 'Santa María Yucuhiti' },
  { id: 447, state_id: 20, name: 'Santa María Zacatepec' },
  { id: 448, state_id: 20, name: 'Santa María Zaniza' },
  { id: 449, state_id: 20, name: 'Santa María Zoquitlán' },
  { id: 450, state_id: 20, name: 'Santiago Amoltepec' },
  { id: 451, state_id: 20, name: 'Santiago Apoala' },
  { id: 452, state_id: 20, name: 'Santiago Apóstol' },
  { id: 453, state_id: 20, name: 'Santiago Astata' },
  { id: 454, state_id: 20, name: 'Santiago Atitlán' },
  { id: 455, state_id: 20, name: 'Santiago Ayuquililla' },
  { id: 456, state_id: 20, name: 'Santiago Cacaloxtepec' },
  { id: 457, state_id: 20, name: 'Santiago Camotlán' },
  { id: 458, state_id: 20, name: 'Santiago Comaltepec' },
  { id: 459, state_id: 20, name: 'Santiago Chazumba' },
  { id: 460, state_id: 20, name: 'Santiago Choápam' },
  { id: 461, state_id: 20, name: 'Santiago del Río' },
  { id: 462, state_id: 20, name: 'Santiago Huajolotitlán' },
  { id: 463, state_id: 20, name: 'Santiago Huauclilla' },
  { id: 464, state_id: 20, name: 'Santiago Ihuitlán Plumas' },
  { id: 465, state_id: 20, name: 'Santiago Ixcuintepec' },
  { id: 466, state_id: 20, name: 'Santiago Ixtayutla' },
  { id: 467, state_id: 20, name: 'Santiago Jamiltepec' },
  { id: 468, state_id: 20, name: 'Santiago Jocotepec' },
  { id: 469, state_id: 20, name: 'Santiago Juxtlahuaca' },
  { id: 470, state_id: 20, name: 'Santiago Lachiguiri' },
  { id: 471, state_id: 20, name: 'Santiago Lalopa' },
  { id: 472, state_id: 20, name: 'Santiago Laollaga' },
  { id: 473, state_id: 20, name: 'Santiago Laxopa' },
  { id: 474, state_id: 20, name: 'Santiago Llano Grande' },
  { id: 475, state_id: 20, name: 'Santiago Matatlán' },
  { id: 476, state_id: 20, name: 'Santiago Miltepec' },
  { id: 477, state_id: 20, name: 'Santiago Minas' },
  { id: 478, state_id: 20, name: 'Santiago Nacaltepec' },
  { id: 479, state_id: 20, name: 'Santiago Nejapilla' },
  { id: 480, state_id: 20, name: 'Santiago Nundiche' },
  { id: 481, state_id: 20, name: 'Santiago Nuyoó' },
  {
    inegi_id: 20482,
    id: 482,
    state_id: 20,
    name: 'Santiago Pinotepa Nacional'
  },
  { id: 483, state_id: 20, name: 'Santiago Suchilquitongo' },
  { id: 484, state_id: 20, name: 'Santiago Tamazola' },
  { id: 485, state_id: 20, name: 'Santiago Tapextla' },
  { id: 486, state_id: 20, name: 'Villa Tejúpam de la Unión' },
  { id: 487, state_id: 20, name: 'Santiago Tenango' },
  { id: 488, state_id: 20, name: 'Santiago Tepetlapa' },
  { id: 489, state_id: 20, name: 'Santiago Tetepec' },
  { id: 490, state_id: 20, name: 'Santiago Texcalcingo' },
  { id: 491, state_id: 20, name: 'Santiago Textitlán' },
  { id: 492, state_id: 20, name: 'Santiago Tilantongo' },
  { id: 493, state_id: 20, name: 'Santiago Tillo' },
  { id: 494, state_id: 20, name: 'Santiago Tlazoyaltepec' },
  { id: 495, state_id: 20, name: 'Santiago Xanica' },
  { id: 496, state_id: 20, name: 'Santiago Xiacuí' },
  { id: 497, state_id: 20, name: 'Santiago Yaitepec' },
  { id: 498, state_id: 20, name: 'Santiago Yaveo' },
  { id: 499, state_id: 20, name: 'Santiago Yolomécatl' },
  { id: 500, state_id: 20, name: 'Santiago Yosondúa' },
  { id: 501, state_id: 20, name: 'Santiago Yucuyachi' },
  { id: 502, state_id: 20, name: 'Santiago Zacatepec' },
  { id: 503, state_id: 20, name: 'Santiago Zoochila' },
  { id: 504, state_id: 20, name: 'Nuevo Zoquiápam' },
  { id: 505, state_id: 20, name: 'Santo Domingo Ingenio' },
  { id: 506, state_id: 20, name: 'Santo Domingo Albarradas' },
  { id: 507, state_id: 20, name: 'Santo Domingo Armenta' },
  { id: 508, state_id: 20, name: 'Santo Domingo Chihuitán' },
  { id: 509, state_id: 20, name: 'Santo Domingo de Morelos' },
  { id: 510, state_id: 20, name: 'Santo Domingo Ixcatlán' },
  { id: 511, state_id: 20, name: 'Santo Domingo Nuxaá' },
  { id: 512, state_id: 20, name: 'Santo Domingo Ozolotepec' },
  { id: 513, state_id: 20, name: 'Santo Domingo Petapa' },
  { id: 514, state_id: 20, name: 'Santo Domingo Roayaga' },
  { id: 515, state_id: 20, name: 'Santo Domingo Tehuantepec' },
  { id: 516, state_id: 20, name: 'Santo Domingo Teojomulco' },
  { id: 517, state_id: 20, name: 'Santo Domingo Tepuxtepec' },
  { id: 518, state_id: 20, name: 'Santo Domingo Tlatayápam' },
  { id: 519, state_id: 20, name: 'Santo Domingo Tomaltepec' },
  { id: 520, state_id: 20, name: 'Santo Domingo Tonalá' },
  { id: 521, state_id: 20, name: 'Santo Domingo Tonaltepec' },
  { id: 522, state_id: 20, name: 'Santo Domingo Xagacía' },
  { id: 523, state_id: 20, name: 'Santo Domingo Yanhuitlán' },
  { id: 524, state_id: 20, name: 'Santo Domingo Yodohino' },
  { id: 525, state_id: 20, name: 'Santo Domingo Zanatepec' },
  { id: 526, state_id: 20, name: 'Santos Reyes Nopala' },
  { id: 527, state_id: 20, name: 'Santos Reyes Pápalo' },
  { id: 528, state_id: 20, name: 'Santos Reyes Tepejillo' },
  { id: 529, state_id: 20, name: 'Santos Reyes Yucuná' },
  { id: 530, state_id: 20, name: 'Santo Tomás Jalieza' },
  { id: 531, state_id: 20, name: 'Santo Tomás Mazaltepec' },
  { id: 532, state_id: 20, name: 'Santo Tomás Ocotepec' },
  { id: 533, state_id: 20, name: 'Santo Tomás Tamazulapan' },
  { id: 534, state_id: 20, name: 'San Vicente Coatlán' },
  { id: 535, state_id: 20, name: 'San Vicente Lachixío' },
  { id: 536, state_id: 20, name: 'San Vicente Nuñú' },
  { id: 537, state_id: 20, name: 'Silacayoápam' },
  { id: 538, state_id: 20, name: 'Sitio de Xitlapehua' },
  { id: 539, state_id: 20, name: 'Soledad Etla' },
  {
    inegi_id: 20540,
    id: 540,
    state_id: 20,
    name: 'Villa de Tamazulápam del Progreso'
  },
  { id: 541, state_id: 20, name: 'Tanetze de Zaragoza' },
  { id: 542, state_id: 20, name: 'Taniche' },
  { id: 543, state_id: 20, name: 'Tataltepec de Valdés' },
  {
    inegi_id: 20544,
    id: 544,
    state_id: 20,
    name: 'Teococuilco de Marcos Pérez'
  },
  { id: 545, state_id: 20, name: 'Teotitlán de Flores Magón' },
  { id: 546, state_id: 20, name: 'Teotitlán del Valle' },
  { id: 547, state_id: 20, name: 'Teotongo' },
  {
    inegi_id: 20548,
    id: 548,
    state_id: 20,
    name: 'Tepelmeme Villa de Morelos'
  },
  {
    inegi_id: 20549,
    id: 549,
    state_id: 20,
    name: 'Tezoatlán de Segura y Luna'
  },
  {
    inegi_id: 20550,
    id: 550,
    state_id: 20,
    name: 'San Jerónimo Tlacochahuaya'
  },
  { id: 551, state_id: 20, name: 'Tlacolula de Matamoros' },
  { id: 552, state_id: 20, name: 'Tlacotepec Plumas' },
  { id: 553, state_id: 20, name: 'Tlalixtac de Cabrera' },
  {
    inegi_id: 20554,
    id: 554,
    state_id: 20,
    name: 'Totontepec Villa de Morelos'
  },
  { id: 555, state_id: 20, name: 'Trinidad Zaachila' },
  { id: 556, state_id: 20, name: 'La Trinidad Vista Hermosa' },
  { id: 557, state_id: 20, name: 'Unión Hidalgo' },
  { id: 558, state_id: 20, name: 'Valerio Trujano' },
  {
    inegi_id: 20559,
    id: 559,
    state_id: 20,
    name: 'San Juan Bautista Valle Nacional'
  },
  { id: 560, state_id: 20, name: 'Villa Díaz Ordaz' },
  { id: 561, state_id: 20, name: 'Yaxe' },
  {
    inegi_id: 20562,
    id: 562,
    state_id: 20,
    name: 'Magdalena Yodocono de Porfirio Díaz'
  },
  { id: 563, state_id: 20, name: 'Yogana' },
  { id: 564, state_id: 20, name: 'Yutanduchi de Guerrero' },
  { id: 565, state_id: 20, name: 'Villa de Zaachila' },
  { id: 566, state_id: 20, name: 'Zapotitlán del Río' },
  { id: 567, state_id: 20, name: 'Zapotitlán Lagunas' },
  { id: 568, state_id: 20, name: 'Zapotitlán Palmas' },
  { id: 569, state_id: 20, name: 'Santa Inés de Zaragoza' },
  { id: 570, state_id: 20, name: 'Zimatlán de Álvarez' },
  { id: 1, state_id: 21, name: 'Acajete' },
  { id: 2, state_id: 21, name: 'Acateno' },
  { id: 3, state_id: 21, name: 'Acatlán' },
  { id: 4, state_id: 21, name: 'Acatzingo' },
  { id: 5, state_id: 21, name: 'Acteopan' },
  { id: 6, state_id: 21, name: 'Ahuacatlán' },
  { id: 7, state_id: 21, name: 'Ahuatlán' },
  { id: 8, state_id: 21, name: 'Ahuazotepec' },
  { id: 9, state_id: 21, name: 'Ahuehuetitla' },
  { id: 10, state_id: 21, name: 'Ajalpan' },
  { id: 11, state_id: 21, name: 'Albino Zertuche' },
  { id: 12, state_id: 21, name: 'Aljojuca' },
  { id: 13, state_id: 21, name: 'Altepexi' },
  { id: 14, state_id: 21, name: 'Amixtlán' },
  { id: 15, state_id: 21, name: 'Amozoc' },
  { id: 16, state_id: 21, name: 'Aquixtla' },
  { id: 17, state_id: 21, name: 'Atempan' },
  { id: 18, state_id: 21, name: 'Atexcal' },
  { id: 19, state_id: 21, name: 'Atlixco' },
  { id: 20, state_id: 21, name: 'Atoyatempan' },
  { id: 21, state_id: 21, name: 'Atzala' },
  { id: 22, state_id: 21, name: 'Atzitzihuacán' },
  { id: 23, state_id: 21, name: 'Atzitzintla' },
  { id: 24, state_id: 21, name: 'Axutla' },
  { id: 25, state_id: 21, name: 'Ayotoxco de Guerrero' },
  { id: 26, state_id: 21, name: 'Calpan' },
  { id: 27, state_id: 21, name: 'Caltepec' },
  { id: 28, state_id: 21, name: 'Camocuautla' },
  { id: 29, state_id: 21, name: 'Caxhuacan' },
  { id: 30, state_id: 21, name: 'Coatepec' },
  { id: 31, state_id: 21, name: 'Coatzingo' },
  { id: 32, state_id: 21, name: 'Cohetzala' },
  { id: 33, state_id: 21, name: 'Cohuecan' },
  { id: 34, state_id: 21, name: 'Coronango' },
  { id: 35, state_id: 21, name: 'Coxcatlán' },
  { id: 36, state_id: 21, name: 'Coyomeapan' },
  { id: 37, state_id: 21, name: 'Coyotepec' },
  { id: 38, state_id: 21, name: 'Cuapiaxtla de Madero' },
  { id: 39, state_id: 21, name: 'Cuautempan' },
  { id: 40, state_id: 21, name: 'Cuautinchán' },
  { id: 41, state_id: 21, name: 'Cuautlancingo' },
  { id: 42, state_id: 21, name: 'Cuayuca de Andrade' },
  { id: 43, state_id: 21, name: 'Cuetzalan del Progreso' },
  { id: 44, state_id: 21, name: 'Cuyoaco' },
  { id: 45, state_id: 21, name: 'Chalchicomula de Sesma' },
  { id: 46, state_id: 21, name: 'Chapulco' },
  { id: 47, state_id: 21, name: 'Chiautla' },
  { id: 48, state_id: 21, name: 'Chiautzingo' },
  { id: 49, state_id: 21, name: 'Chiconcuautla' },
  { id: 50, state_id: 21, name: 'Chichiquila' },
  { id: 51, state_id: 21, name: 'Chietla' },
  { id: 52, state_id: 21, name: 'Chigmecatitlán' },
  { id: 53, state_id: 21, name: 'Chignahuapan' },
  { id: 54, state_id: 21, name: 'Chignautla' },
  { id: 55, state_id: 21, name: 'Chila' },
  { id: 56, state_id: 21, name: 'Chila de la Sal' },
  { id: 57, state_id: 21, name: 'Honey' },
  { id: 58, state_id: 21, name: 'Chilchotla' },
  { id: 59, state_id: 21, name: 'Chinantla' },
  { id: 60, state_id: 21, name: 'Domingo Arenas' },
  { id: 61, state_id: 21, name: 'Eloxochitlán' },
  { id: 62, state_id: 21, name: 'Epatlán' },
  { id: 63, state_id: 21, name: 'Esperanza' },
  { id: 64, state_id: 21, name: 'Francisco Z. Mena' },
  { id: 65, state_id: 21, name: 'General Felipe Ángeles' },
  { id: 66, state_id: 21, name: 'Guadalupe' },
  { id: 67, state_id: 21, name: 'Guadalupe Victoria' },
  { id: 68, state_id: 21, name: 'Hermenegildo Galeana' },
  { id: 69, state_id: 21, name: 'Huaquechula' },
  { id: 70, state_id: 21, name: 'Huatlatlauca' },
  { id: 71, state_id: 21, name: 'Huauchinango' },
  { id: 72, state_id: 21, name: 'Huehuetla' },
  { id: 73, state_id: 21, name: 'Huehuetlán el Chico' },
  { id: 74, state_id: 21, name: 'Huejotzingo' },
  { id: 75, state_id: 21, name: 'Hueyapan' },
  { id: 76, state_id: 21, name: 'Hueytamalco' },
  { id: 77, state_id: 21, name: 'Hueytlalpan' },
  { id: 78, state_id: 21, name: 'Huitzilan de Serdán' },
  { id: 79, state_id: 21, name: 'Huitziltepec' },
  { id: 80, state_id: 21, name: 'Atlequizayán' },
  { id: 81, state_id: 21, name: 'Ixcamilpa de Guerrero' },
  { id: 82, state_id: 21, name: 'Ixcaquixtla' },
  { id: 83, state_id: 21, name: 'Ixtacamaxtitlán' },
  { id: 84, state_id: 21, name: 'Ixtepec' },
  { id: 85, state_id: 21, name: 'Izúcar de Matamoros' },
  { id: 86, state_id: 21, name: 'Jalpan' },
  { id: 87, state_id: 21, name: 'Jolalpan' },
  { id: 88, state_id: 21, name: 'Jonotla' },
  { id: 89, state_id: 21, name: 'Jopala' },
  { id: 90, state_id: 21, name: 'Juan C. Bonilla' },
  { id: 91, state_id: 21, name: 'Juan Galindo' },
  { id: 92, state_id: 21, name: 'Juan N. Méndez' },
  { id: 93, state_id: 21, name: 'Lafragua' },
  { id: 94, state_id: 21, name: 'Libres' },
  {
    inegi_id: 21095,
    id: 95,
    state_id: 21,
    name: 'La Magdalena Tlatlauquitepec'
  },
  { id: 96, state_id: 21, name: 'Mazapiltepec de Juárez' },
  { id: 97, state_id: 21, name: 'Mixtla' },
  { id: 98, state_id: 21, name: 'Molcaxac' },
  { id: 99, state_id: 21, name: 'Cañada Morelos' },
  { id: 100, state_id: 21, name: 'Naupan' },
  { id: 101, state_id: 21, name: 'Nauzontla' },
  { id: 102, state_id: 21, name: 'Nealtican' },
  { id: 103, state_id: 21, name: 'Nicolás Bravo' },
  { id: 104, state_id: 21, name: 'Nopalucan' },
  { id: 105, state_id: 21, name: 'Ocotepec' },
  { id: 106, state_id: 21, name: 'Ocoyucan' },
  { id: 107, state_id: 21, name: 'Olintla' },
  { id: 108, state_id: 21, name: 'Oriental' },
  { id: 109, state_id: 21, name: 'Pahuatlán' },
  { id: 110, state_id: 21, name: 'Palmar de Bravo' },
  { id: 111, state_id: 21, name: 'Pantepec' },
  { id: 112, state_id: 21, name: 'Petlalcingo' },
  { id: 113, state_id: 21, name: 'Piaxtla' },
  { id: 114, state_id: 21, name: 'Puebla' },
  { id: 115, state_id: 21, name: 'Quecholac' },
  { id: 116, state_id: 21, name: 'Quimixtlán' },
  { id: 117, state_id: 21, name: 'Rafael Lara Grajales' },
  { id: 118, state_id: 21, name: 'Los Reyes de Juárez' },
  { id: 119, state_id: 21, name: 'San Andrés Cholula' },
  { id: 120, state_id: 21, name: 'San Antonio Cañada' },
  {
    inegi_id: 21121,
    id: 121,
    state_id: 21,
    name: 'San Diego la Mesa Tochimiltzingo'
  },
  { id: 122, state_id: 21, name: 'San Felipe Teotlalcingo' },
  { id: 123, state_id: 21, name: 'San Felipe Tepatlán' },
  { id: 124, state_id: 21, name: 'San Gabriel Chilac' },
  { id: 125, state_id: 21, name: 'San Gregorio Atzompa' },
  { id: 126, state_id: 21, name: 'San Jerónimo Tecuanipan' },
  { id: 127, state_id: 21, name: 'San Jerónimo Xayacatlán' },
  { id: 128, state_id: 21, name: 'San José Chiapa' },
  { id: 129, state_id: 21, name: 'San José Miahuatlán' },
  { id: 130, state_id: 21, name: 'San Juan Atenco' },
  { id: 131, state_id: 21, name: 'San Juan Atzompa' },
  { id: 132, state_id: 21, name: 'San Martín Texmelucan' },
  { id: 133, state_id: 21, name: 'San Martín Totoltepec' },
  { id: 134, state_id: 21, name: 'San Matías Tlalancaleca' },
  { id: 135, state_id: 21, name: 'San Miguel Ixitlán' },
  { id: 136, state_id: 21, name: 'San Miguel Xoxtla' },
  { id: 137, state_id: 21, name: 'San Nicolás Buenos Aires' },
  {
    inegi_id: 21138,
    id: 138,
    state_id: 21,
    name: 'San Nicolás de los Ranchos'
  },
  { id: 139, state_id: 21, name: 'San Pablo Anicano' },
  { id: 140, state_id: 21, name: 'San Pedro Cholula' },
  { id: 141, state_id: 21, name: 'San Pedro Yeloixtlahuaca' },
  { id: 142, state_id: 21, name: 'San Salvador el Seco' },
  { id: 143, state_id: 21, name: 'San Salvador el Verde' },
  { id: 144, state_id: 21, name: 'San Salvador Huixcolotla' },
  { id: 145, state_id: 21, name: 'San Sebastián Tlacotepec' },
  { id: 146, state_id: 21, name: 'Santa Catarina Tlaltempan' },
  { id: 147, state_id: 21, name: 'Santa Inés Ahuatempan' },
  { id: 148, state_id: 21, name: 'Santa Isabel Cholula' },
  { id: 149, state_id: 21, name: 'Santiago Miahuatlán' },
  { id: 150, state_id: 21, name: 'Huehuetlán el Grande' },
  { id: 151, state_id: 21, name: 'Santo Tomás Hueyotlipan' },
  { id: 152, state_id: 21, name: 'Soltepec' },
  { id: 153, state_id: 21, name: 'Tecali de Herrera' },
  { id: 154, state_id: 21, name: 'Tecamachalco' },
  { id: 155, state_id: 21, name: 'Tecomatlán' },
  { id: 156, state_id: 21, name: 'Tehuacán' },
  { id: 157, state_id: 21, name: 'Tehuitzingo' },
  { id: 158, state_id: 21, name: 'Tenampulco' },
  { id: 159, state_id: 21, name: 'Teopantlán' },
  { id: 160, state_id: 21, name: 'Teotlalco' },
  { id: 161, state_id: 21, name: 'Tepanco de López' },
  { id: 162, state_id: 21, name: 'Tepango de Rodríguez' },
  { id: 163, state_id: 21, name: 'Tepatlaxco de Hidalgo' },
  { id: 164, state_id: 21, name: 'Tepeaca' },
  { id: 165, state_id: 21, name: 'Tepemaxalco' },
  { id: 166, state_id: 21, name: 'Tepeojuma' },
  { id: 167, state_id: 21, name: 'Tepetzintla' },
  { id: 168, state_id: 21, name: 'Tepexco' },
  { id: 169, state_id: 21, name: 'Tepexi de Rodríguez' },
  { id: 170, state_id: 21, name: 'Tepeyahualco' },
  {
    inegi_id: 21171,
    id: 171,
    state_id: 21,
    name: 'Tepeyahualco de Cuauhtémoc'
  },
  { id: 172, state_id: 21, name: 'Tetela de Ocampo' },
  { id: 173, state_id: 21, name: 'Teteles de Ávila Castillo' },
  { id: 174, state_id: 21, name: 'Teziutlán' },
  { id: 175, state_id: 21, name: 'Tianguismanalco' },
  { id: 176, state_id: 21, name: 'Tilapa' },
  {
    inegi_id: 21177,
    id: 177,
    state_id: 21,
    name: 'Tlacotepec de Benito Juárez'
  },
  { id: 178, state_id: 21, name: 'Tlacuilotepec' },
  { id: 179, state_id: 21, name: 'Tlachichuca' },
  { id: 180, state_id: 21, name: 'Tlahuapan' },
  { id: 181, state_id: 21, name: 'Tlaltenango' },
  { id: 182, state_id: 21, name: 'Tlanepantla' },
  { id: 183, state_id: 21, name: 'Tlaola' },
  { id: 184, state_id: 21, name: 'Tlapacoya' },
  { id: 185, state_id: 21, name: 'Tlapanalá' },
  { id: 186, state_id: 21, name: 'Tlatlauquitepec' },
  { id: 187, state_id: 21, name: 'Tlaxco' },
  { id: 188, state_id: 21, name: 'Tochimilco' },
  { id: 189, state_id: 21, name: 'Tochtepec' },
  { id: 190, state_id: 21, name: 'Totoltepec de Guerrero' },
  { id: 191, state_id: 21, name: 'Tulcingo' },
  { id: 192, state_id: 21, name: 'Tuzamapan de Galeana' },
  { id: 193, state_id: 21, name: 'Tzicatlacoyan' },
  { id: 194, state_id: 21, name: 'Venustiano Carranza' },
  { id: 195, state_id: 21, name: 'Vicente Guerrero' },
  { id: 196, state_id: 21, name: 'Xayacatlán de Bravo' },
  { id: 197, state_id: 21, name: 'Xicotepec' },
  { id: 198, state_id: 21, name: 'Xicotlán' },
  { id: 199, state_id: 21, name: 'Xiutetelco' },
  { id: 200, state_id: 21, name: 'Xochiapulco' },
  { id: 201, state_id: 21, name: 'Xochiltepec' },
  {
    inegi_id: 21202,
    id: 202,
    state_id: 21,
    name: 'Xochitlán de Vicente Suárez'
  },
  { id: 203, state_id: 21, name: 'Xochitlán Todos Santos' },
  { id: 204, state_id: 21, name: 'Yaonáhuac' },
  { id: 205, state_id: 21, name: 'Yehualtepec' },
  { id: 206, state_id: 21, name: 'Zacapala' },
  { id: 207, state_id: 21, name: 'Zacapoaxtla' },
  { id: 208, state_id: 21, name: 'Zacatlán' },
  { id: 209, state_id: 21, name: 'Zapotitlán' },
  { id: 210, state_id: 21, name: 'Zapotitlán de Méndez' },
  { id: 211, state_id: 21, name: 'Zaragoza' },
  { id: 212, state_id: 21, name: 'Zautla' },
  { id: 213, state_id: 21, name: 'Zihuateutla' },
  { id: 214, state_id: 21, name: 'Zinacatepec' },
  { id: 215, state_id: 21, name: 'Zongozotla' },
  { id: 216, state_id: 21, name: 'Zoquiapan' },
  { id: 217, state_id: 21, name: 'Zoquitlán' },
  { id: 1, state_id: 22, name: 'Amealco de Bonfil' },
  { id: 2, state_id: 22, name: 'Pinal de Amoles' },
  { id: 3, state_id: 22, name: 'Arroyo Seco' },
  { id: 4, state_id: 22, name: 'Cadereyta de Montes' },
  { id: 5, state_id: 22, name: 'Colón' },
  { id: 6, state_id: 22, name: 'Corregidora' },
  { id: 7, state_id: 22, name: 'Ezequiel Montes' },
  { id: 8, state_id: 22, name: 'Huimilpan' },
  { id: 9, state_id: 22, name: 'Jalpan de Serra' },
  { id: 10, state_id: 22, name: 'Landa de Matamoros' },
  { id: 11, state_id: 22, name: 'El Marqués' },
  { id: 12, state_id: 22, name: 'Pedro Escobedo' },
  { id: 13, state_id: 22, name: 'Peñamiller' },
  { id: 14, state_id: 22, name: 'Querétaro' },
  { id: 15, state_id: 22, name: 'San Joaquín' },
  { id: 16, state_id: 22, name: 'San Juan del Río' },
  { id: 17, state_id: 22, name: 'Tequisquiapan' },
  { id: 18, state_id: 22, name: 'Tolimán' },
  { id: 1, state_id: 23, name: 'Cozumel' },
  { id: 2, state_id: 23, name: 'Felipe Carrillo Puerto' },
  { id: 3, state_id: 23, name: 'Isla Mujeres' },
  { id: 4, state_id: 23, name: 'Othón P. Blanco' },
  { id: 5, state_id: 23, name: 'Benito Juárez' },
  { id: 6, state_id: 23, name: 'José María Morelos' },
  { id: 7, state_id: 23, name: 'Lázaro Cárdenas' },
  { id: 8, state_id: 23, name: 'Solidaridad' },
  { id: 9, state_id: 23, name: 'Tulum' },
  { id: 1, state_id: 24, name: 'Ahualulco' },
  { id: 2, state_id: 24, name: 'Alaquines' },
  { id: 3, state_id: 24, name: 'Aquismón' },
  { id: 4, state_id: 24, name: 'Armadillo de los Infante' },
  { id: 5, state_id: 24, name: 'Cárdenas' },
  { id: 6, state_id: 24, name: 'Catorce' },
  { id: 7, state_id: 24, name: 'Cedral' },
  { id: 8, state_id: 24, name: 'Cerritos' },
  { id: 9, state_id: 24, name: 'Cerro de San Pedro' },
  { id: 10, state_id: 24, name: 'Ciudad del Maíz' },
  { id: 11, state_id: 24, name: 'Ciudad Fernández' },
  { id: 12, state_id: 24, name: 'Tancanhuitz' },
  { id: 13, state_id: 24, name: 'Ciudad Valles' },
  { id: 14, state_id: 24, name: 'Coxcatlán' },
  { id: 15, state_id: 24, name: 'Charcas' },
  { id: 16, state_id: 24, name: 'Ebano' },
  { id: 17, state_id: 24, name: 'Guadalcázar' },
  { id: 18, state_id: 24, name: 'Huehuetlán' },
  { id: 19, state_id: 24, name: 'Lagunillas' },
  { id: 20, state_id: 24, name: 'Matehuala' },
  { id: 21, state_id: 24, name: 'Mexquitic de Carmona' },
  { id: 22, state_id: 24, name: 'Moctezuma' },
  { id: 23, state_id: 24, name: 'Rayón' },
  { id: 24, state_id: 24, name: 'Rioverde' },
  { id: 25, state_id: 24, name: 'Salinas' },
  { id: 26, state_id: 24, name: 'San Antonio' },
  { id: 27, state_id: 24, name: 'San Ciro de Acosta' },
  { id: 28, state_id: 24, name: 'San Luis Potosí' },
  { id: 29, state_id: 24, name: 'San Martín Chalchicuautla' },
  { id: 30, state_id: 24, name: 'San Nicolás Tolentino' },
  { id: 31, state_id: 24, name: 'Santa Catarina' },
  { id: 32, state_id: 24, name: 'Santa María del Río' },
  { id: 33, state_id: 24, name: 'Santo Domingo' },
  { id: 34, state_id: 24, name: 'San Vicente Tancuayalab' },
  {
    inegi_id: 24035,
    id: 35,
    state_id: 24,
    name: 'Soledad de Graciano Sánchez'
  },
  { id: 36, state_id: 24, name: 'Tamasopo' },
  { id: 37, state_id: 24, name: 'Tamazunchale' },
  { id: 38, state_id: 24, name: 'Tampacán' },
  { id: 39, state_id: 24, name: 'Tampamolón Corona' },
  { id: 40, state_id: 24, name: 'Tamuín' },
  { id: 41, state_id: 24, name: 'Tanlajás' },
  { id: 42, state_id: 24, name: 'Tanquián de Escobedo' },
  { id: 43, state_id: 24, name: 'Tierra Nueva' },
  { id: 44, state_id: 24, name: 'Vanegas' },
  { id: 45, state_id: 24, name: 'Venado' },
  { id: 46, state_id: 24, name: 'Villa de Arriaga' },
  { id: 47, state_id: 24, name: 'Villa de Guadalupe' },
  { id: 48, state_id: 24, name: 'Villa de la Paz' },
  { id: 49, state_id: 24, name: 'Villa de Ramos' },
  { id: 50, state_id: 24, name: 'Villa de Reyes' },
  { id: 51, state_id: 24, name: 'Villa Hidalgo' },
  { id: 52, state_id: 24, name: 'Villa Juárez' },
  { id: 53, state_id: 24, name: 'Axtla de Terrazas' },
  { id: 54, state_id: 24, name: 'Xilitla' },
  { id: 55, state_id: 24, name: 'Zaragoza' },
  { id: 56, state_id: 24, name: 'Villa de Arista' },
  { id: 57, state_id: 24, name: 'Matlapa' },
  { id: 58, state_id: 24, name: 'El Naranjo' },
  { id: 1, state_id: 25, name: 'Ahome' },
  { id: 2, state_id: 25, name: 'Angostura' },
  { id: 3, state_id: 25, name: 'Badiraguato' },
  { id: 4, state_id: 25, name: 'Concordia' },
  { id: 5, state_id: 25, name: 'Cosalá' },
  { id: 6, state_id: 25, name: 'Culiacán' },
  { id: 7, state_id: 25, name: 'Choix' },
  { id: 8, state_id: 25, name: 'Elota' },
  { id: 9, state_id: 25, name: 'Escuinapa' },
  { id: 10, state_id: 25, name: 'El Fuerte' },
  { id: 11, state_id: 25, name: 'Guasave' },
  { id: 12, state_id: 25, name: 'Mazatlán' },
  { id: 13, state_id: 25, name: 'Mocorito' },
  { id: 14, state_id: 25, name: 'Rosario' },
  { id: 15, state_id: 25, name: 'Salvador Alvarado' },
  { id: 16, state_id: 25, name: 'San Ignacio' },
  { id: 17, state_id: 25, name: 'Sinaloa' },
  { id: 18, state_id: 25, name: 'Navolato' },
  { id: 1, state_id: 26, name: 'Aconchi' },
  { id: 2, state_id: 26, name: 'Agua Prieta' },
  { id: 3, state_id: 26, name: 'Alamos' },
  { id: 4, state_id: 26, name: 'Altar' },
  { id: 5, state_id: 26, name: 'Arivechi' },
  { id: 6, state_id: 26, name: 'Arizpe' },
  { id: 7, state_id: 26, name: 'Atil' },
  { id: 8, state_id: 26, name: 'Bacadéhuachi' },
  { id: 9, state_id: 26, name: 'Bacanora' },
  { id: 10, state_id: 26, name: 'Bacerac' },
  { id: 11, state_id: 26, name: 'Bacoachi' },
  { id: 12, state_id: 26, name: 'Bácum' },
  { id: 13, state_id: 26, name: 'Banámichi' },
  { id: 14, state_id: 26, name: 'Baviácora' },
  { id: 15, state_id: 26, name: 'Bavispe' },
  { id: 16, state_id: 26, name: 'Benjamín Hill' },
  { id: 17, state_id: 26, name: 'Caborca' },
  { id: 18, state_id: 26, name: 'Cajeme' },
  { id: 19, state_id: 26, name: 'Cananea' },
  { id: 20, state_id: 26, name: 'Carbó' },
  { id: 21, state_id: 26, name: 'La Colorada' },
  { id: 22, state_id: 26, name: 'Cucurpe' },
  { id: 23, state_id: 26, name: 'Cumpas' },
  { id: 24, state_id: 26, name: 'Divisaderos' },
  { id: 25, state_id: 26, name: 'Empalme' },
  { id: 26, state_id: 26, name: 'Etchojoa' },
  { id: 27, state_id: 26, name: 'Fronteras' },
  { id: 28, state_id: 26, name: 'Granados' },
  { id: 29, state_id: 26, name: 'Guaymas' },
  { id: 30, state_id: 26, name: 'Hermosillo' },
  { id: 31, state_id: 26, name: 'Huachinera' },
  { id: 32, state_id: 26, name: 'Huásabas' },
  { id: 33, state_id: 26, name: 'Huatabampo' },
  { id: 34, state_id: 26, name: 'Huépac' },
  { id: 35, state_id: 26, name: 'Imuris' },
  { id: 36, state_id: 26, name: 'Magdalena' },
  { id: 37, state_id: 26, name: 'Mazatán' },
  { id: 38, state_id: 26, name: 'Moctezuma' },
  { id: 39, state_id: 26, name: 'Naco' },
  { id: 40, state_id: 26, name: 'Nácori Chico' },
  { id: 41, state_id: 26, name: 'Nacozari de García' },
  { id: 42, state_id: 26, name: 'Navojoa' },
  { id: 43, state_id: 26, name: 'Nogales' },
  { id: 44, state_id: 26, name: 'Onavas' },
  { id: 45, state_id: 26, name: 'Opodepe' },
  { id: 46, state_id: 26, name: 'Oquitoa' },
  { id: 47, state_id: 26, name: 'Pitiquito' },
  { id: 48, state_id: 26, name: 'Puerto Peñasco' },
  { id: 49, state_id: 26, name: 'Quiriego' },
  { id: 50, state_id: 26, name: 'Rayón' },
  { id: 51, state_id: 26, name: 'Rosario' },
  { id: 52, state_id: 26, name: 'Sahuaripa' },
  { id: 53, state_id: 26, name: 'San Felipe de Jesús' },
  { id: 54, state_id: 26, name: 'San Javier' },
  { id: 55, state_id: 26, name: 'San Luis Río Colorado' },
  { id: 56, state_id: 26, name: 'San Miguel de Horcasitas' },
  { id: 57, state_id: 26, name: 'San Pedro de la Cueva' },
  { id: 58, state_id: 26, name: 'Santa Ana' },
  { id: 59, state_id: 26, name: 'Santa Cruz' },
  { id: 60, state_id: 26, name: 'Sáric' },
  { id: 61, state_id: 26, name: 'Soyopa' },
  { id: 62, state_id: 26, name: 'Suaqui Grande' },
  { id: 63, state_id: 26, name: 'Tepache' },
  { id: 64, state_id: 26, name: 'Trincheras' },
  { id: 65, state_id: 26, name: 'Tubutama' },
  { id: 66, state_id: 26, name: 'Ures' },
  { id: 67, state_id: 26, name: 'Villa Hidalgo' },
  { id: 68, state_id: 26, name: 'Villa Pesqueira' },
  { id: 69, state_id: 26, name: 'Yécora' },
  {
    inegi_id: 26070,
    id: 70,
    state_id: 26,
    name: 'General Plutarco Elías Calles'
  },
  { id: 71, state_id: 26, name: 'Benito Juárez' },
  { id: 72, state_id: 26, name: 'San Ignacio Río Muerto' },
  { id: 1, state_id: 27, name: 'Balancán' },
  { id: 2, state_id: 27, name: 'Cárdenas' },
  { id: 3, state_id: 27, name: 'Centla' },
  { id: 4, state_id: 27, name: 'Centro' },
  { id: 5, state_id: 27, name: 'Comalcalco' },
  { id: 6, state_id: 27, name: 'Cunduacán' },
  { id: 7, state_id: 27, name: 'Emiliano Zapata' },
  { id: 8, state_id: 27, name: 'Huimanguillo' },
  { id: 9, state_id: 27, name: 'Jalapa' },
  { id: 10, state_id: 27, name: 'Jalpa de Méndez' },
  { id: 11, state_id: 27, name: 'Jonuta' },
  { id: 12, state_id: 27, name: 'Macuspana' },
  { id: 13, state_id: 27, name: 'Nacajuca' },
  { id: 14, state_id: 27, name: 'Paraíso' },
  { id: 15, state_id: 27, name: 'Tacotalpa' },
  { id: 16, state_id: 27, name: 'Teapa' },
  { id: 17, state_id: 27, name: 'Tenosique' },
  { id: 1, state_id: 28, name: 'Abasolo' },
  { id: 2, state_id: 28, name: 'Aldama' },
  { id: 3, state_id: 28, name: 'Altamira' },
  { id: 4, state_id: 28, name: 'Antiguo Morelos' },
  { id: 5, state_id: 28, name: 'Burgos' },
  { id: 6, state_id: 28, name: 'Bustamante' },
  { id: 7, state_id: 28, name: 'Camargo' },
  { id: 8, state_id: 28, name: 'Casas' },
  { id: 9, state_id: 28, name: 'Ciudad Madero' },
  { id: 10, state_id: 28, name: 'Cruillas' },
  { id: 11, state_id: 28, name: 'Gómez Farías' },
  { id: 12, state_id: 28, name: 'González' },
  { id: 13, state_id: 28, name: 'Güémez' },
  { id: 14, state_id: 28, name: 'Guerrero' },
  { id: 15, state_id: 28, name: 'Gustavo Díaz Ordaz' },
  { id: 16, state_id: 28, name: 'Hidalgo' },
  { id: 17, state_id: 28, name: 'Jaumave' },
  { id: 18, state_id: 28, name: 'Jiménez' },
  { id: 19, state_id: 28, name: 'Llera' },
  { id: 20, state_id: 28, name: 'Mainero' },
  { id: 21, state_id: 28, name: 'El Mante' },
  { id: 22, state_id: 28, name: 'Matamoros' },
  { id: 23, state_id: 28, name: 'Méndez' },
  { id: 24, state_id: 28, name: 'Mier' },
  { id: 25, state_id: 28, name: 'Miguel Alemán' },
  { id: 26, state_id: 28, name: 'Miquihuana' },
  { id: 27, state_id: 28, name: 'Nuevo Laredo' },
  { id: 28, state_id: 28, name: 'Nuevo Morelos' },
  { id: 29, state_id: 28, name: 'Ocampo' },
  { id: 30, state_id: 28, name: 'Padilla' },
  { id: 31, state_id: 28, name: 'Palmillas' },
  { id: 32, state_id: 28, name: 'Reynosa' },
  { id: 33, state_id: 28, name: 'Río Bravo' },
  { id: 34, state_id: 28, name: 'San Carlos' },
  { id: 35, state_id: 28, name: 'San Fernando' },
  { id: 36, state_id: 28, name: 'San Nicolás' },
  { id: 37, state_id: 28, name: 'Soto la Marina' },
  { id: 38, state_id: 28, name: 'Tampico' },
  { id: 39, state_id: 28, name: 'Tula' },
  { id: 40, state_id: 28, name: 'Valle Hermoso' },
  { id: 41, state_id: 28, name: 'Victoria' },
  { id: 42, state_id: 28, name: 'Villagrán' },
  { id: 43, state_id: 28, name: 'Xicoténcatl' },
  { id: 1, state_id: 29, name: 'Amaxac de Guerrero' },
  {
    inegi_id: 29002,
    id: 2,
    state_id: 29,
    name: 'Apetatitlán de Antonio Carvajal'
  },
  { id: 3, state_id: 29, name: 'Atlangatepec' },
  { id: 4, state_id: 29, name: 'Altzayanca' },
  { id: 5, state_id: 29, name: 'Apizaco' },
  { id: 6, state_id: 29, name: 'Calpulalpan' },
  { id: 7, state_id: 29, name: 'El Carmen Tequexquitla' },
  { id: 8, state_id: 29, name: 'Cuapiaxtla' },
  { id: 9, state_id: 29, name: 'Cuaxomulco' },
  { id: 10, state_id: 29, name: 'Chiautempan' },
  { id: 11, state_id: 29, name: 'Muñoz de Domingo Arenas' },
  { id: 12, state_id: 29, name: 'Españita' },
  { id: 13, state_id: 29, name: 'Huamantla' },
  { id: 14, state_id: 29, name: 'Hueyotlipan' },
  {
    inegi_id: 29015,
    id: 15,
    state_id: 29,
    name: 'Ixtacuixtla de Mariano Matamoros'
  },
  { id: 16, state_id: 29, name: 'Ixtenco' },
  {
    inegi_id: 29017,
    id: 17,
    state_id: 29,
    name: 'Mazatecochco de José María Morelos'
  },
  { id: 18, state_id: 29, name: 'Contla de Juan Cuamatzi' },
  { id: 19, state_id: 29, name: 'Tepetitla de Lardizábal' },
  {
    inegi_id: 29020,
    id: 20,
    state_id: 29,
    name: 'Sanctórum de Lázaro Cárdenas'
  },
  {
    inegi_id: 29021,
    id: 21,
    state_id: 29,
    name: 'Nanacamilpa de Mariano Arista'
  },
  {
    inegi_id: 29022,
    id: 22,
    state_id: 29,
    name: 'Acuamanala de Miguel Hidalgo'
  },
  { id: 23, state_id: 29, name: 'Natívitas' },
  { id: 24, state_id: 29, name: 'Panotla' },
  { id: 25, state_id: 29, name: 'San Pablo del Monte' },
  { id: 26, state_id: 29, name: 'Santa Cruz Tlaxcala' },
  { id: 27, state_id: 29, name: 'Tenancingo' },
  { id: 28, state_id: 29, name: 'Teolocholco' },
  { id: 29, state_id: 29, name: 'Tepeyanco' },
  { id: 30, state_id: 29, name: 'Terrenate' },
  { id: 31, state_id: 29, name: 'Tetla de la Solidaridad' },
  { id: 32, state_id: 29, name: 'Tetlatlahuca' },
  { id: 33, state_id: 29, name: 'Tlaxcala' },
  { id: 34, state_id: 29, name: 'Tlaxco' },
  { id: 35, state_id: 29, name: 'Tocatlán' },
  { id: 36, state_id: 29, name: 'Totolac' },
  {
    inegi_id: 29037,
    id: 37,
    state_id: 29,
    name: 'Zitlaltepec de Trinidad Sánchez Santos'
  },
  { id: 38, state_id: 29, name: 'Tzompantepec' },
  { id: 39, state_id: 29, name: 'Xaloztoc' },
  { id: 40, state_id: 29, name: 'Xaltocan' },
  { id: 41, state_id: 29, name: 'Papalotla de Xicohténcatl' },
  { id: 42, state_id: 29, name: 'Xicohtzinco' },
  { id: 43, state_id: 29, name: 'Yauhquemecan' },
  { id: 44, state_id: 29, name: 'Zacatelco' },
  { id: 45, state_id: 29, name: 'Benito Juárez' },
  { id: 46, state_id: 29, name: 'Emiliano Zapata' },
  { id: 47, state_id: 29, name: 'Lázaro Cárdenas' },
  { id: 48, state_id: 29, name: 'La Magdalena Tlaltelulco' },
  { id: 49, state_id: 29, name: 'San Damián Texoloc' },
  { id: 50, state_id: 29, name: 'San Francisco Tetlanohcan' },
  { id: 51, state_id: 29, name: 'San Jerónimo Zacualpan' },
  { id: 52, state_id: 29, name: 'San José Teacalco' },
  { id: 53, state_id: 29, name: 'San Juan Huactzinco' },
  { id: 54, state_id: 29, name: 'San Lorenzo Axocomanitla' },
  { id: 55, state_id: 29, name: 'San Lucas Tecopilco' },
  { id: 56, state_id: 29, name: 'Santa Ana Nopalucan' },
  { id: 57, state_id: 29, name: 'Santa Apolonia Teacalco' },
  { id: 58, state_id: 29, name: 'Santa Catarina Ayometla' },
  { id: 59, state_id: 29, name: 'Santa Cruz Quilehtla' },
  { id: 60, state_id: 29, name: 'Santa Isabel Xiloxoxtla' },
  { id: 1, state_id: 30, name: 'Acajete' },
  { id: 2, state_id: 30, name: 'Acatlán' },
  { id: 3, state_id: 30, name: 'Acayucan' },
  { id: 4, state_id: 30, name: 'Actopan' },
  { id: 5, state_id: 30, name: 'Acula' },
  { id: 6, state_id: 30, name: 'Acultzingo' },
  { id: 7, state_id: 30, name: 'Camarón de Tejeda' },
  { id: 8, state_id: 30, name: 'Alpatláhuac' },
  {
    inegi_id: 30009,
    id: 9,
    state_id: 30,
    name: 'Alto Lucero de Gutiérrez Barrios'
  },
  { id: 10, state_id: 30, name: 'Altotonga' },
  { id: 11, state_id: 30, name: 'Alvarado' },
  { id: 12, state_id: 30, name: 'Amatitlán' },
  { id: 13, state_id: 30, name: 'Naranjos Amatlán' },
  { id: 14, state_id: 30, name: 'Amatlán de los Reyes' },
  { id: 15, state_id: 30, name: 'Angel R. Cabada' },
  { id: 16, state_id: 30, name: 'La Antigua' },
  { id: 17, state_id: 30, name: 'Apazapan' },
  { id: 18, state_id: 30, name: 'Aquila' },
  { id: 19, state_id: 30, name: 'Astacinga' },
  { id: 20, state_id: 30, name: 'Atlahuilco' },
  { id: 21, state_id: 30, name: 'Atoyac' },
  { id: 22, state_id: 30, name: 'Atzacan' },
  { id: 23, state_id: 30, name: 'Atzalan' },
  { id: 24, state_id: 30, name: 'Tlaltetela' },
  { id: 25, state_id: 30, name: 'Ayahualulco' },
  { id: 26, state_id: 30, name: 'Banderilla' },
  { id: 27, state_id: 30, name: 'Benito Juárez' },
  { id: 28, state_id: 30, name: 'Boca del Río' },
  { id: 29, state_id: 30, name: 'Calcahualco' },
  { id: 30, state_id: 30, name: 'Camerino Z. Mendoza' },
  { id: 31, state_id: 30, name: 'Carrillo Puerto' },
  { id: 32, state_id: 30, name: 'Catemaco' },
  { id: 33, state_id: 30, name: 'Cazones' },
  { id: 34, state_id: 30, name: 'Cerro Azul' },
  { id: 35, state_id: 30, name: 'Citlaltépetl' },
  { id: 36, state_id: 30, name: 'Coacoatzintla' },
  { id: 37, state_id: 30, name: 'Coahuitlán' },
  { id: 38, state_id: 30, name: 'Coatepec' },
  { id: 39, state_id: 30, name: 'Coatzacoalcos' },
  { id: 40, state_id: 30, name: 'Coatzintla' },
  { id: 41, state_id: 30, name: 'Coetzala' },
  { id: 42, state_id: 30, name: 'Colipa' },
  { id: 43, state_id: 30, name: 'Comapa' },
  { id: 44, state_id: 30, name: 'Córdoba' },
  { id: 45, state_id: 30, name: 'Cosamaloapan de Carpio' },
  { id: 46, state_id: 30, name: 'Cosautlán de Carvajal' },
  { id: 47, state_id: 30, name: 'Coscomatepec' },
  { id: 48, state_id: 30, name: 'Cosoleacaque' },
  { id: 49, state_id: 30, name: 'Cotaxtla' },
  { id: 50, state_id: 30, name: 'Coxquihui' },
  { id: 51, state_id: 30, name: 'Coyutla' },
  { id: 52, state_id: 30, name: 'Cuichapa' },
  { id: 53, state_id: 30, name: 'Cuitláhuac' },
  { id: 54, state_id: 30, name: 'Chacaltianguis' },
  { id: 55, state_id: 30, name: 'Chalma' },
  { id: 56, state_id: 30, name: 'Chiconamel' },
  { id: 57, state_id: 30, name: 'Chiconquiaco' },
  { id: 58, state_id: 30, name: 'Chicontepec' },
  { id: 59, state_id: 30, name: 'Chinameca' },
  { id: 60, state_id: 30, name: 'Chinampa de Gorostiza' },
  { id: 61, state_id: 30, name: 'Las Choapas' },
  { id: 62, state_id: 30, name: 'Chocamán' },
  { id: 63, state_id: 30, name: 'Chontla' },
  { id: 64, state_id: 30, name: 'Chumatlán' },
  { id: 65, state_id: 30, name: 'Emiliano Zapata' },
  { id: 66, state_id: 30, name: 'Espinal' },
  { id: 67, state_id: 30, name: 'Filomeno Mata' },
  { id: 68, state_id: 30, name: 'Fortín' },
  { id: 69, state_id: 30, name: 'Gutiérrez Zamora' },
  { id: 70, state_id: 30, name: 'Hidalgotitlán' },
  { id: 71, state_id: 30, name: 'Huatusco' },
  { id: 72, state_id: 30, name: 'Huayacocotla' },
  { id: 73, state_id: 30, name: 'Hueyapan de Ocampo' },
  { id: 74, state_id: 30, name: 'Huiloapan' },
  { id: 75, state_id: 30, name: 'Ignacio de la Llave' },
  { id: 76, state_id: 30, name: 'Ilamatlán' },
  { id: 77, state_id: 30, name: 'Isla' },
  { id: 78, state_id: 30, name: 'Ixcatepec' },
  { id: 79, state_id: 30, name: 'Ixhuacán de los Reyes' },
  { id: 80, state_id: 30, name: 'Ixhuatlán del Café' },
  { id: 81, state_id: 30, name: 'Ixhuatlancillo' },
  { id: 82, state_id: 30, name: 'Ixhuatlán del Sureste' },
  { id: 83, state_id: 30, name: 'Ixhuatlán de Madero' },
  { id: 84, state_id: 30, name: 'Ixmatlahuacan' },
  { id: 85, state_id: 30, name: 'Ixtaczoquitlán' },
  { id: 86, state_id: 30, name: 'Jalacingo' },
  { id: 87, state_id: 30, name: 'Xalapa' },
  { id: 88, state_id: 30, name: 'Jalcomulco' },
  { id: 89, state_id: 30, name: 'Jáltipan' },
  { id: 90, state_id: 30, name: 'Jamapa' },
  { id: 91, state_id: 30, name: 'Jesús Carranza' },
  { id: 92, state_id: 30, name: 'Xico' },
  { id: 93, state_id: 30, name: 'Jilotepec' },
  { id: 94, state_id: 30, name: 'Juan Rodríguez Clara' },
  { id: 95, state_id: 30, name: 'Juchique de Ferrer' },
  { id: 96, state_id: 30, name: 'Landero y Coss' },
  { id: 97, state_id: 30, name: 'Lerdo de Tejada' },
  { id: 98, state_id: 30, name: 'Magdalena' },
  { id: 99, state_id: 30, name: 'Maltrata' },
  { id: 100, state_id: 30, name: 'Manlio Fabio Altamirano' },
  { id: 101, state_id: 30, name: 'Mariano Escobedo' },
  { id: 102, state_id: 30, name: 'Martínez de la Torre' },
  { id: 103, state_id: 30, name: 'Mecatlán' },
  { id: 104, state_id: 30, name: 'Mecayapan' },
  { id: 105, state_id: 30, name: 'Medellín' },
  { id: 106, state_id: 30, name: 'Miahuatlán' },
  { id: 107, state_id: 30, name: 'Las Minas' },
  { id: 108, state_id: 30, name: 'Minatitlán' },
  { id: 109, state_id: 30, name: 'Misantla' },
  { id: 110, state_id: 30, name: 'Mixtla de Altamirano' },
  { id: 111, state_id: 30, name: 'Moloacán' },
  { id: 112, state_id: 30, name: 'Naolinco' },
  { id: 113, state_id: 30, name: 'Naranjal' },
  { id: 114, state_id: 30, name: 'Nautla' },
  { id: 115, state_id: 30, name: 'Nogales' },
  { id: 116, state_id: 30, name: 'Oluta' },
  { id: 117, state_id: 30, name: 'Omealca' },
  { id: 118, state_id: 30, name: 'Orizaba' },
  { id: 119, state_id: 30, name: 'Otatitlán' },
  { id: 120, state_id: 30, name: 'Oteapan' },
  { id: 121, state_id: 30, name: 'Ozuluama de Mascareñas' },
  { id: 122, state_id: 30, name: 'Pajapan' },
  { id: 123, state_id: 30, name: 'Pánuco' },
  { id: 124, state_id: 30, name: 'Papantla' },
  { id: 125, state_id: 30, name: 'Paso del Macho' },
  { id: 126, state_id: 30, name: 'Paso de Ovejas' },
  { id: 127, state_id: 30, name: 'La Perla' },
  { id: 128, state_id: 30, name: 'Perote' },
  { id: 129, state_id: 30, name: 'Platón Sánchez' },
  { id: 130, state_id: 30, name: 'Playa Vicente' },
  { id: 131, state_id: 30, name: 'Poza Rica de Hidalgo' },
  { id: 132, state_id: 30, name: 'Las Vigas de Ramírez' },
  { id: 133, state_id: 30, name: 'Pueblo Viejo' },
  { id: 134, state_id: 30, name: 'Puente Nacional' },
  { id: 135, state_id: 30, name: 'Rafael Delgado' },
  { id: 136, state_id: 30, name: 'Rafael Lucio' },
  { id: 137, state_id: 30, name: 'Los Reyes' },
  { id: 138, state_id: 30, name: 'Río Blanco' },
  { id: 139, state_id: 30, name: 'Saltabarranca' },
  { id: 140, state_id: 30, name: 'San Andrés Tenejapan' },
  { id: 141, state_id: 30, name: 'San Andrés Tuxtla' },
  { id: 142, state_id: 30, name: 'San Juan Evangelista' },
  { id: 143, state_id: 30, name: 'Santiago Tuxtla' },
  { id: 144, state_id: 30, name: 'Sayula de Alemán' },
  { id: 145, state_id: 30, name: 'Soconusco' },
  { id: 146, state_id: 30, name: 'Sochiapa' },
  { id: 147, state_id: 30, name: 'Soledad Atzompa' },
  { id: 148, state_id: 30, name: 'Soledad de Doblado' },
  { id: 149, state_id: 30, name: 'Soteapan' },
  { id: 150, state_id: 30, name: 'Tamalín' },
  { id: 151, state_id: 30, name: 'Tamiahua' },
  { id: 152, state_id: 30, name: 'Tampico Alto' },
  { id: 153, state_id: 30, name: 'Tancoco' },
  { id: 154, state_id: 30, name: 'Tantima' },
  { id: 155, state_id: 30, name: 'Tantoyuca' },
  { id: 156, state_id: 30, name: 'Tatatila' },
  { id: 157, state_id: 30, name: 'Castillo de Teayo' },
  { id: 158, state_id: 30, name: 'Tecolutla' },
  { id: 159, state_id: 30, name: 'Tehuipango' },
  { id: 160, state_id: 30, name: 'Temapache' },
  { id: 161, state_id: 30, name: 'Tempoal' },
  { id: 162, state_id: 30, name: 'Tenampa' },
  { id: 163, state_id: 30, name: 'Tenochtitlán' },
  { id: 164, state_id: 30, name: 'Teocelo' },
  { id: 165, state_id: 30, name: 'Tepatlaxco' },
  { id: 166, state_id: 30, name: 'Tepetlán' },
  { id: 167, state_id: 30, name: 'Tepetzintla' },
  { id: 168, state_id: 30, name: 'Tequila' },
  { id: 169, state_id: 30, name: 'José Azueta' },
  { id: 170, state_id: 30, name: 'Texcatepec' },
  { id: 171, state_id: 30, name: 'Texhuacán' },
  { id: 172, state_id: 30, name: 'Texistepec' },
  { id: 173, state_id: 30, name: 'Tezonapa' },
  { id: 174, state_id: 30, name: 'Tierra Blanca' },
  { id: 175, state_id: 30, name: 'Tihuatlán' },
  { id: 176, state_id: 30, name: 'Tlacojalpan' },
  { id: 177, state_id: 30, name: 'Tlacolulan' },
  { id: 178, state_id: 30, name: 'Tlacotalpan' },
  { id: 179, state_id: 30, name: 'Tlacotepec de Mejía' },
  { id: 180, state_id: 30, name: 'Tlachichilco' },
  { id: 181, state_id: 30, name: 'Tlalixcoyan' },
  { id: 182, state_id: 30, name: 'Tlalnelhuayocan' },
  { id: 183, state_id: 30, name: 'Tlapacoyan' },
  { id: 184, state_id: 30, name: 'Tlaquilpa' },
  { id: 185, state_id: 30, name: 'Tlilapan' },
  { id: 186, state_id: 30, name: 'Tomatlán' },
  { id: 187, state_id: 30, name: 'Tonayán' },
  { id: 188, state_id: 30, name: 'Totutla' },
  { id: 189, state_id: 30, name: 'Túxpam' },
  { id: 190, state_id: 30, name: 'Tuxtilla' },
  { id: 191, state_id: 30, name: 'Ursulo Galván' },
  { id: 192, state_id: 30, name: 'Vega de Alatorre' },
  { id: 193, state_id: 30, name: 'Veracruz' },
  { id: 194, state_id: 30, name: 'Villa Aldama' },
  { id: 195, state_id: 30, name: 'Xoxocotla' },
  { id: 196, state_id: 30, name: 'Yanga' },
  { id: 197, state_id: 30, name: 'Yecuatla' },
  { id: 198, state_id: 30, name: 'Zacualpan' },
  { id: 199, state_id: 30, name: 'Zaragoza' },
  { id: 200, state_id: 30, name: 'Zentla' },
  { id: 201, state_id: 30, name: 'Zongolica' },
  {
    inegi_id: 30202,
    id: 202,
    state_id: 30,
    name: 'Zontecomatlán de López y Fuentes'
  },
  { id: 203, state_id: 30, name: 'Zozocolco de Hidalgo' },
  { id: 204, state_id: 30, name: 'Agua Dulce' },
  { id: 205, state_id: 30, name: 'El Higo' },
  {
    inegi_id: 30206,
    id: 206,
    state_id: 30,
    name: 'Nanchital de Lázaro Cárdenas del Río'
  },
  { id: 207, state_id: 30, name: 'Tres Valles' },
  { id: 208, state_id: 30, name: 'Carlos A. Carrillo' },
  { id: 209, state_id: 30, name: 'Tatahuicapan de Juárez' },
  { id: 210, state_id: 30, name: 'Uxpanapa' },
  { id: 211, state_id: 30, name: 'San Rafael' },
  { id: 212, state_id: 30, name: 'Santiago Sochiapan' },
  { id: 1, state_id: 31, name: 'Abalá' },
  { id: 2, state_id: 31, name: 'Acanceh' },
  { id: 3, state_id: 31, name: 'Akil' },
  { id: 4, state_id: 31, name: 'Baca' },
  { id: 5, state_id: 31, name: 'Bokobá' },
  { id: 6, state_id: 31, name: 'Buctzotz' },
  { id: 7, state_id: 31, name: 'Cacalchén' },
  { id: 8, state_id: 31, name: 'Calotmul' },
  { id: 9, state_id: 31, name: 'Cansahcab' },
  { id: 10, state_id: 31, name: 'Cantamayec' },
  { id: 11, state_id: 31, name: 'Celestún' },
  { id: 12, state_id: 31, name: 'Cenotillo' },
  { id: 13, state_id: 31, name: 'Conkal' },
  { id: 14, state_id: 31, name: 'Cuncunul' },
  { id: 15, state_id: 31, name: 'Cuzamá' },
  { id: 16, state_id: 31, name: 'Chacsinkín' },
  { id: 17, state_id: 31, name: 'Chankom' },
  { id: 18, state_id: 31, name: 'Chapab' },
  { id: 19, state_id: 31, name: 'Chemax' },
  { id: 20, state_id: 31, name: 'Chicxulub Pueblo' },
  { id: 21, state_id: 31, name: 'Chichimilá' },
  { id: 22, state_id: 31, name: 'Chikindzonot' },
  { id: 23, state_id: 31, name: 'Chocholá' },
  { id: 24, state_id: 31, name: 'Chumayel' },
  { id: 25, state_id: 31, name: 'Dzán' },
  { id: 26, state_id: 31, name: 'Dzemul' },
  { id: 27, state_id: 31, name: 'Dzidzantún' },
  { id: 28, state_id: 31, name: 'Dzilam de Bravo' },
  { id: 29, state_id: 31, name: 'Dzilam González' },
  { id: 30, state_id: 31, name: 'Dzitás' },
  { id: 31, state_id: 31, name: 'Dzoncauich' },
  { id: 32, state_id: 31, name: 'Espita' },
  { id: 33, state_id: 31, name: 'Halachó' },
  { id: 34, state_id: 31, name: 'Hocabá' },
  { id: 35, state_id: 31, name: 'Hoctún' },
  { id: 36, state_id: 31, name: 'Homún' },
  { id: 37, state_id: 31, name: 'Huhí' },
  { id: 38, state_id: 31, name: 'Hunucmá' },
  { id: 39, state_id: 31, name: 'Ixil' },
  { id: 40, state_id: 31, name: 'Izamal' },
  { id: 41, state_id: 31, name: 'Kanasín' },
  { id: 42, state_id: 31, name: 'Kantunil' },
  { id: 43, state_id: 31, name: 'Kaua' },
  { id: 44, state_id: 31, name: 'Kinchil' },
  { id: 45, state_id: 31, name: 'Kopomá' },
  { id: 46, state_id: 31, name: 'Mama' },
  { id: 47, state_id: 31, name: 'Maní' },
  { id: 48, state_id: 31, name: 'Maxcanú' },
  { id: 49, state_id: 31, name: 'Mayapán' },
  { id: 50, state_id: 31, name: 'Mérida' },
  { id: 51, state_id: 31, name: 'Mocochá' },
  { id: 52, state_id: 31, name: 'Motul' },
  { id: 53, state_id: 31, name: 'Muna' },
  { id: 54, state_id: 31, name: 'Muxupip' },
  { id: 55, state_id: 31, name: 'Opichén' },
  { id: 56, state_id: 31, name: 'Oxkutzcab' },
  { id: 57, state_id: 31, name: 'Panabá' },
  { id: 58, state_id: 31, name: 'Peto' },
  { id: 59, state_id: 31, name: 'Progreso' },
  { id: 60, state_id: 31, name: 'Quintana Roo' },
  { id: 61, state_id: 31, name: 'Río Lagartos' },
  { id: 62, state_id: 31, name: 'Sacalum' },
  { id: 63, state_id: 31, name: 'Samahil' },
  { id: 64, state_id: 31, name: 'Sanahcat' },
  { id: 65, state_id: 31, name: 'San Felipe' },
  { id: 66, state_id: 31, name: 'Santa Elena' },
  { id: 67, state_id: 31, name: 'Seyé' },
  { id: 68, state_id: 31, name: 'Sinanché' },
  { id: 69, state_id: 31, name: 'Sotuta' },
  { id: 70, state_id: 31, name: 'Sucilá' },
  { id: 71, state_id: 31, name: 'Sudzal' },
  { id: 72, state_id: 31, name: 'Suma' },
  { id: 73, state_id: 31, name: 'Tahdziú' },
  { id: 74, state_id: 31, name: 'Tahmek' },
  { id: 75, state_id: 31, name: 'Teabo' },
  { id: 76, state_id: 31, name: 'Tecoh' },
  { id: 77, state_id: 31, name: 'Tekal de Venegas' },
  { id: 78, state_id: 31, name: 'Tekantó' },
  { id: 79, state_id: 31, name: 'Tekax' },
  { id: 80, state_id: 31, name: 'Tekit' },
  { id: 81, state_id: 31, name: 'Tekom' },
  { id: 82, state_id: 31, name: 'Telchac Pueblo' },
  { id: 83, state_id: 31, name: 'Telchac Puerto' },
  { id: 84, state_id: 31, name: 'Temax' },
  { id: 85, state_id: 31, name: 'Temozón' },
  { id: 86, state_id: 31, name: 'Tepakán' },
  { id: 87, state_id: 31, name: 'Tetiz' },
  { id: 88, state_id: 31, name: 'Teya' },
  { id: 89, state_id: 31, name: 'Ticul' },
  { id: 90, state_id: 31, name: 'Timucuy' },
  { id: 91, state_id: 31, name: 'Tinum' },
  { id: 92, state_id: 31, name: 'Tixcacalcupul' },
  { id: 93, state_id: 31, name: 'Tixkokob' },
  { id: 94, state_id: 31, name: 'Tixmehuac' },
  { id: 95, state_id: 31, name: 'Tixpéhual' },
  { id: 96, state_id: 31, name: 'Tizimín' },
  { id: 97, state_id: 31, name: 'Tunkás' },
  { id: 98, state_id: 31, name: 'Tzucacab' },
  { id: 99, state_id: 31, name: 'Uayma' },
  { id: 100, state_id: 31, name: 'Ucú' },
  { id: 101, state_id: 31, name: 'Umán' },
  { id: 102, state_id: 31, name: 'Valladolid' },
  { id: 103, state_id: 31, name: 'Xocchel' },
  { id: 104, state_id: 31, name: 'Yaxcabá' },
  { id: 105, state_id: 31, name: 'Yaxkukul' },
  { id: 106, state_id: 31, name: 'Yobaín' },
  { id: 1, state_id: 32, name: 'Apozol' },
  { id: 2, state_id: 32, name: 'Apulco' },
  { id: 3, state_id: 32, name: 'Atolinga' },
  { id: 4, state_id: 32, name: 'Benito Juárez' },
  { id: 5, state_id: 32, name: 'Calera' },
  { id: 6, state_id: 32, name: 'Cañitas de Felipe Pescador' },
  { id: 7, state_id: 32, name: 'Concepción del Oro' },
  { id: 8, state_id: 32, name: 'Cuauhtémoc' },
  { id: 9, state_id: 32, name: 'Chalchihuites' },
  { id: 10, state_id: 32, name: 'Fresnillo' },
  {
    inegi_id: 32011,
    id: 11,
    state_id: 32,
    name: 'Trinidad García de la Cadena'
  },
  { id: 12, state_id: 32, name: 'Genaro Codina' },
  { id: 13, state_id: 32, name: 'General Enrique Estrada' },
  {
    inegi_id: 32014,
    id: 14,
    state_id: 32,
    name: 'General Francisco R. Murguía'
  },
  {
    inegi_id: 32015,
    id: 15,
    state_id: 32,
    name: 'El Plateado de Joaquín Amaro'
  },
  { id: 16, state_id: 32, name: 'General Pánfilo Natera' },
  { id: 17, state_id: 32, name: 'Guadalupe' },
  { id: 18, state_id: 32, name: 'Huanusco' },
  { id: 19, state_id: 32, name: 'Jalpa' },
  { id: 20, state_id: 32, name: 'Jerez' },
  { id: 21, state_id: 32, name: 'Jiménez del Teul' },
  { id: 22, state_id: 32, name: 'Juan Aldama' },
  { id: 23, state_id: 32, name: 'Juchipila' },
  { id: 24, state_id: 32, name: 'Loreto' },
  { id: 25, state_id: 32, name: 'Luis Moya' },
  { id: 26, state_id: 32, name: 'Mazapil' },
  { id: 27, state_id: 32, name: 'Melchor Ocampo' },
  { id: 28, state_id: 32, name: 'Mezquital del Oro' },
  { id: 29, state_id: 32, name: 'Miguel Auza' },
  { id: 30, state_id: 32, name: 'Momax' },
  { id: 31, state_id: 32, name: 'Monte Escobedo' },
  { id: 32, state_id: 32, name: 'Morelos' },
  { id: 33, state_id: 32, name: 'Moyahua de Estrada' },
  { id: 34, state_id: 32, name: 'Nochistlán de Mejía' },
  { id: 35, state_id: 32, name: 'Noria de Ángeles' },
  { id: 36, state_id: 32, name: 'Ojocaliente' },
  { id: 37, state_id: 32, name: 'Pánuco' },
  { id: 38, state_id: 32, name: 'Pinos' },
  { id: 39, state_id: 32, name: 'Río Grande' },
  { id: 40, state_id: 32, name: 'Sain Alto' },
  { id: 41, state_id: 32, name: 'El Salvador' },
  { id: 42, state_id: 32, name: 'Sombrerete' },
  { id: 43, state_id: 32, name: 'Susticacán' },
  { id: 44, state_id: 32, name: 'Tabasco' },
  { id: 45, state_id: 32, name: 'Tepechitlán' },
  { id: 46, state_id: 32, name: 'Tepetongo' },
  { id: 47, state_id: 32, name: 'Teul de González Ortega' },
  {
    inegi_id: 32048,
    id: 48,
    state_id: 32,
    name: 'Tlaltenango de Sánchez Román'
  },
  { id: 49, state_id: 32, name: 'Valparaíso' },
  { id: 50, state_id: 32, name: 'Vetagrande' },
  { id: 51, state_id: 32, name: 'Villa de Cos' },
  { id: 52, state_id: 32, name: 'Villa García' },
  { id: 53, state_id: 32, name: 'Villa González Ortega' },
  { id: 54, state_id: 32, name: 'Villa Hidalgo' },
  { id: 55, state_id: 32, name: 'Villanueva' },
  { id: 56, state_id: 32, name: 'Zacatecas' },
  { id: 57, state_id: 32, name: 'Trancoso' },
  { id: 58, state_id: 32, name: 'Santa María de la Paz' }
]



// WEBPACK FOOTER //
// ./src/constantes/municipios.js